const translations = {
  en: {
    // Navigation
    home: "Home",
    services: "Services",
    navContact: "Contact",
    navPro: "Pro",
    navCustomCircuit: "Custom Circuit",
    adminLabel: "Admin",
    profileLabel: "Profile",
    langEnglish: "English",
    langFrench: "French",
    logoutConfirmTitle: "Confirmation",
    logoutConfirmMessage: "Are you sure you want to log out?",
    destinations: "Destinations",
    about: "About",
//     contact: "Contact",
//     // Hero Section
    heroTitle: "TOURISM TRIPS IN MOROCCO\nBy Palais Touristique",
    heroSubtitle: "Experience authentic Moroccan culture with our comprehensive travel services",
    searchPlaceholder: "Where would you like to go?",
    checkin: "Check-in",
    checkout: "Check-out",
//     guests: "Guests",
    guest: "Guest",
    searchButton: "Search & Book",
    // Hero - Reserve button (per tab)
    reserve: "Book",
    reserveStay: "Book a stay",
    reserveCircuit: "Book a circuit",
    reserveTransport: "Book transport",
//     reserveCar: "Book a car",
//     reserveTour: "Book a tour",
//
    heroHint: "Tip: choose a tab then click Book to open the corresponding form.",
    stayCheckIn: "Check-in",
    stayCheckOut: "Check-out",
    carPickupDate: "Pick-up",
    carReturnDate: "Return",
    circuitTravelDate: "Travel date",
    transportDate: "Departure date",
    visitDate: "Visit date",
    heroPickDates: "Choose your dates",
    heroPickDate: "Choose a date",

    // Hero Tabs
    tabSejour: "Stay",
    tabSejourShort: "Stay",
    tabCircuit: "Circuit",
    tabCircuitShort: "Circuit",
    tabTransport: "Transport",
    tabTransportShort: "Transport",
    tabLocation: "Car Rental",
    tabLocationShort: "Rental",
    tabVisite: "Guided Tour",
    tabVisiteShort: "Visit",
    // Services
    servicesTitle: "Our Services",
    servicesSubtitle: "Everything you need for an unforgettable Moroccan adventure",
    servicesHeroTitlePrefix: "Explore the",
    servicesHeroTitleHighlight: "Wonders",
    servicesHeroTitleSuffix: "of Morocco",
    servicesViewCircuitsCta: "View circuits",
    servicesCustomRequestCta: "Custom request",
    servicesWhatWeOffer: "What we offer",
    servicesPopularDestinationsBadge: "Popular destinations",
    servicesDiscoverTitlePrefix: "Discover",
    servicesDiscoverTitleHighlight: "Morocco",
    servicesJourneyTitlePrefix: "Your",
    servicesJourneyTitleHighlight: "Journey",
    servicesJourneyTitleSuffix: "with Nouzha",
    servicesStepLabel: "Step",
    servicesTrustSupportTitle: "7/7 support",
    servicesTrustSupportDesc: "Responsive local team before, during, and after your trip.",
    servicesTrustSupportValue: "< 15 min",
    servicesTrustPaymentTitle: "Secure payment",
    servicesTrustPaymentDesc: "Protected transactions via verified payment gateways.",
    servicesTrustPaymentValue: "CMI + Stripe",
    servicesTrustCustomTitle: "Tailored offers",
    servicesTrustCustomDesc: "Experiences adapted to your style, pace, and budget.",
    servicesTrustCustomValue: "100% flexible",
    servicesStatsClientsLabel: "Satisfied clients",
    servicesStatsCircuitsLabel: "Available circuits",
    servicesStatsCitiesLabel: "Covered cities",
    servicesStatsRatingLabel: "Average rating",
    serviceWifi: "Wi-Fi",
    serviceParking: "Parking",
    serviceRestaurant: "Restaurant",
    serviceSpa: "Spa",
    servicePool: "Pool",
    servicePrivateBeach: "Private beach",
    serviceGolf: "Golf",
    serviceSauna: "Sauna",
    riads: "Riads & Hotels",
    riadsDesc: "Authentic Moroccan riads and luxury hotels in imperial cities",
    circuits: "Circuits & Tours",
    circuitsDesc: "Guided tours through the Atlas Mountains, Sahara Desert, and ancient medinas",
    carRental: "Car Rental",
//     carRentalDesc: "Explore Morocco at your own pace with our reliable vehicles",
//     transport: "Tourist Transport",
    transportDesc: "Comfortable transportation between cities and tourist sites",
    guidedTours: "Guided Tours",
//     guidedToursDesc: "Expert local guides to show you hidden gems and cultural treasures",
    professionals: "Professional Space",
    professionalsDesc:
      "Access the Pro space for partners: agencies, drivers, guides, and providers. Manage requests, availability, and collaboration easily.",

    // Services page - generic CTA link on cards
    explore: "Explore",
    // Why Choose Us
    whyChooseTitle: "Why Choose Palais Touristique?",
    whyChooseSubtitle: "Your trusted partner for authentic Moroccan experiences",
    localExpertise: "Local Expertise",
    localExpertiseDesc: "Native guides with deep knowledge of Moroccan culture and history",
    bestPrices: "Best Prices",
    bestPricesDesc: "Competitive rates with no hidden fees and price matching",
//     support: "24/7 Support",
    supportDesc: "Round-the-clock assistance in multiple languages",
    authenticity: "Authentic Experiences",
    authenticityDesc: "Genuine cultural immersion with local families and traditions",
    // Destinations
    destinationsTitle: "Popular Destinations",
    destinationsSubtitle: "Discover Morocco's most enchanting places",
    marrakech: "Marrakech",
    marrakechDesc: "The Red City with its bustling souks and historic palaces",
    fez: "Fez",
    fezDesc: "The cultural capital with the world's largest medina",
    casablanca: "Casablanca",
    casablancaDesc: "Modern metropolis with stunning Hassan II Mosque",
    sahara: "Sahara Desert",
    saharaDesc: "Unforgettable desert camps and camel trekking adventures",
    chefchaouen: "Chefchaouen",
    chefchaouenDesc: "The blue pearl nestled in the Rif Mountains",
    essaouira: "Essaouira",
    essaouiraDesc: "Coastal charm with Portuguese architecture and fresh seafood",
    // Testimonials
    testimonialsTitle: "What Our Travelers Say",
    testimonialsSubtitle: "Real experiences from real adventurers",
    // CTA
    ctaTitle: "Ready for Your Moroccan Adventure?",
    ctaSubtitle: "Join thousands of travelers who've discovered Morocco with us",
    startBooking: "Start Your Journey",
    downloadApp: "Download App",
    // Footer
    company: "Company",
    aboutUs: "About Us",
    careers: "Careers",
    press: "Press",
    blog: "Blog",
    support: "Support",
    helpCenter: "Help Center",
//     contactUs: "Contact Us",
    cancellation: "Cancellation",
    safety: "Safety",
    legal: "Legal",
    privacy: "Privacy Policy",
    terms: "Terms of Service",
    cookies: "Cookie Policy",
    rights: "All rights reserved",
    
    // Legal Pages
    // Terms of Service
    termsTitle: "Terms of Service",
    termsPreambule: "Preamble",
    termsPreambuleContent: "These general terms of use (GTU) are intended to define the terms and conditions of use of the PALAIS TOURISTIQUE website, accessible at www.PALAISTOURISTIQUE.ma, as well as the rights and obligations of site users.\n\nThe use of the site implies full acceptance of these GTU. These terms of use are subject to change or completion at any time.",
    termsSiteAccess: "Site Access",
    termsSiteAccessContent: "The site is freely accessible to any user with internet access. All costs related to site access, whether hardware, software or internet access costs are exclusively borne by the user.\n\nAccess to certain sections of the site may require the creation of a user account. In this case, the user undertakes to provide accurate information and to maintain the confidentiality of their login credentials.",
    termsServices: "Services Offered",
    termsServicesContent: "Personalized advice\nSearch for high-potential real estate\nTransformation services (design, renovation, furnishing)\nAdministrative and financial support\nCustomer tracking platform",
    termsUserCommitments: "User Commitments",
    termsUserCommitmentsContent: "Not to disrupt the proper functioning of the site\nNot to use information fraudulently\nRespect intellectual property rights",
    termsIntellectualProperty: "Intellectual Property",
    termsIntellectualPropertyContent: "The site and all of its content (texts, visuals, logo, tools) are protected by laws in force on intellectual property. Any reproduction, representation, modification or use, total or partial, without prior authorization is strictly prohibited.",
    termsLiabilityLimitation: "Limitation of Liability",
    termsLiabilityLimitationContent: "PALAIS TOURISTIQUE implements all necessary means to provide a reliable service, but cannot be held responsible for possible errors or interruptions.",
    termsApplicableLaw: "Applicable Law and Competent Jurisdiction",
    termsApplicableLawContent: "These GTU are subject to Moroccan law. In case of dispute, only the competent court of Casablanca will be competent.",
    
    // Privacy Policy
    privacyTitle: "Privacy Policy",
    privacyIntroduction: "Introduction",
    privacyIntroductionContent: "This policy explains how Palais Touristique collects, uses and protects your personal data, in accordance with Moroccan law 09-08 on data protection.",
    privacyDataCollection: "Personal Data Collection",
    privacyDataCollectionContent: "We collect the following personal data:\n\n• Identity data: name, first name, date of birth\n• Contact data: email address, telephone number, postal address\n• Connection data: IP address, cookies, browsing data\n• Transaction data: payment information, reservation history",
    privacyDataUse: "Use of Personal Data",
    privacyDataUseContent: "Your personal data is used for:\n\n• Processing your reservations and requests\n• Improving our services\n• Sending you commercial information (with your consent)\n• Complying with our legal obligations",
    privacyDataSharing: "Data Sharing",
    privacyDataSharingContent: "We do not sell or rent your personal data to third parties. We may share your data with:\n\n• Our service providers (hotels, transport companies)\n• Competent authorities when required by law\n• Our technical partners for site operation",
    privacyDataSecurity: "Data Security",
    privacyDataSecurityContent: "We implement appropriate technical and organizational measures to protect your personal data against unauthorized access, alteration, disclosure or destruction.",
    privacyYourRights: "Your Rights",
    privacyYourRightsContent: "You have the right to:\n\n• Access your personal data\n• Rectify inaccurate data\n• Delete your data under certain conditions\n• Object to the processing of your data\n• Data portability",
    privacyContact: "Contact",
    privacyContactContent: "For any questions regarding this privacy policy, you can contact us at: contact@palaisTouristique.ma",
    
    // Legal Mentions
    mentionsTitle: "Legal Mentions",
    mentionsCompliance: "In accordance with law n° 34-05 relating to information society services in Morocco.",
    mentionsSiteEditor: "Site Editor",
    mentionsSiteEditorContent: "PALAIS TOURISTIQUE\nHeadquarters: Fez, Morocco\nPhone: +212 651-913292\nEmail: contact@palaisTouristique.ma",
    mentionsIntellectualProperty: "Intellectual Property",
    mentionsIntellectualPropertyContent: "All content on this site (texts, images, videos, etc.) is protected by laws relating to intellectual property. Any reproduction or representation, in whole or in part, by any process whatsoever, made without the consent of PALAIS TOURISTIQUE, is unlawful.",
    
    // Cookie Policy
    cookiesTitle: "Cookie Policy",
    cookiesWhatIs: "What is a cookie?",
    cookiesWhatIsContent: "A cookie is a small text file placed on your device (computer, tablet or mobile phone) when you visit our site. It allows us to collect information about your browsing and offer you adapted services.",
    cookiesWeUse: "Cookies we use",
    cookiesWeUseContent: "Our site uses different types of cookies:\n\n• Technical cookies: necessary for the operation of the site and the use of main functionalities\n• Audience measurement cookies: to establish statistics on site traffic and usage\n• Personalization cookies: to adapt the site presentation according to your preferences\n• Advertising cookies: to offer you content adapted to your interests",
    cookiesManagement: "Cookie Management",
    cookiesManagementContent: "You can choose to disable these cookies at any time. Your browser can also be configured to notify you of cookies placed and ask you to accept or refuse them.\n\nYou can accept or refuse cookies on a case-by-case basis or refuse them systematically. The configuration may modify your access conditions to our services requiring the use of cookies.",
    cookiesBrowserConfig: "How to configure your browser",
    cookiesBrowserConfigContent: "Each browser configuration is different. Consult your browser's help menu to learn how to modify your cookie preferences.\n\n• For Google Chrome: Google Chrome Help\n• For Mozilla Firefox: Mozilla Firefox Help\n• For Microsoft Edge: Microsoft Edge Help\n• For Safari: Safari Help",
    cookiesRetention: "Cookie Retention Period",
    cookiesRetentionContent: "Cookies are kept for a maximum period of 13 months from their deposit on your device.",
    
    // Common Legal Terms
    lastUpdated: "Last updated:",
    // Buttons
    exploreOptions: "Explore Options",
    viewCircuits: "View Circuits",
//     rentNow: "Rent Now",
    bookTransport: "Book Transport",
    browseTours: "Browse Tours",
    seeAll: "See All Services",
    viewHotels: "View Hotels",
//     from: "from",
//     
//     // Welcome message
    welcome: "Welcome",
    logout: "Logout",
    
    // Additional translations
    discoverAllServices: "Discover all our services for a complete experience",
    seeMore: "See more",
    
    // Badges
    popular: "Popular",
//     cultural: "Cultural",
    modern: "Modern",
//     adventure: "Adventure",
    unique: "Unique",
    coastal: "Coastal",
    
    // Testimonials
    testimonial1: "An absolutely magical experience! The riad in Marrakech was breathtaking, and our guide showed us places we never would have found on our own.",
    testimonial2: "Perfect organization from start to finish. The Sahara desert tour was the highlight of our trip. Highly recommended!",
    testimonial3: "Authentic Moroccan experience with excellent service. The cooking class in Fez was incredible!",
    testimonialsLoadErrorPrefix: "Unable to load testimonials",
    testimonialsLoadErrorFallback: "Showing examples.",
    homeCircuit1Title: "Atlas Prestige",
    homeCircuit1Subtitle: "Marrakech • Berber valleys • Desert",
    homeCircuit1Duration: "7 days",
    homeCircuit2Title: "Sahara Signature",
    homeCircuit2Subtitle: "Ouarzazate • Merzouga • Golden dunes",
    homeCircuit2Duration: "5 days",
    homeCircuit3Title: "Imperial Route",
    homeCircuit3Subtitle: "Fez • Meknes • Rabat • Casablanca",
    homeCircuit3Duration: "6 days",
    homeCollection1Title: "Weekend from Fez",
    homeCollection1Subtitle: "Short escapes, premium comfort",
    homeCollection1Duration: "2-3 days",
    homeCollection2Title: "Desert Luxury",
    homeCollection2Subtitle: "High-end camp and starry sky",
    homeCollection2Duration: "3-5 days",
    homeCollection3Title: "Family Friendly",
    homeCollection3Subtitle: "Flexible itineraries for families",
    homeCollection3Duration: "4-7 days",
    homePremiumBadge: "Premium Collection",
    homePremiumTitle: "Visual circuits, high-end agency style",
    homePremiumDescription: "Live the ultimate Moroccan experience with our carefully crafted tours.",
    homePremiumTrustLine: "Hundreds of travelers already trust us.",
    homePremiumSeeAll: "See all",
    homeCollectionsBadge: "Collections",
    homeCollectionsTitle: "Inspiration of the moment",
    homeCollectionsSeeAll: "View all",
    
    // Search bar common elements
//     date: "Date",
    time: "Time",
    city: "City",
//     enterCity: "Enter a city",
//     
//     // Transport tab
    sourceCity: "Source City",
    destinationCity: "Destination City",
    enterSourceCity: "Enter departure city",
    enterDestinationCity: "Enter arrival city",
    
    // Car rental tab
//     carType: "Car Type",
    enterCarType: "Enter car type",
    
    // Additional translations for the search bar
    trustPartnerDesc: "Your trusted partner to discover Morocco's authenticity",
    // Contact Page
    contact: "Phone",
    contactUs: "Contact Us",
    contactHeroTitle: "We are at your <span class='text-orange-600'>service</span>",
    contactHeroDesc: "A question about our services or a personalized request? Our PalaisTouristique team is here to help you with your project.",
    contactAvgResponse15m: "Average response in under 15 minutes",
    contactHotlineTitle: "Direct hotline",
    contactHotlineDesc: "Call now for immediate assistance.",
    contactAppointmentTitle: "Appointment",
    contactScheduleCall: "Schedule a call",
    contactAppointmentDesc: "Choose a slot with our travel team.",
    contactPriorityEmailTitle: "Priority email",
    contactPriorityEmailDesc: "Send your brief and receive a detailed proposal.",
    sendMessage: "Send us a message",
//     fullName: "Full Name",
//     fullNamePlaceholder: "Your name",
//     emailPlaceholder: "Your email",
    telephone: "Phone",
    telephonePlaceholder: "Your number",
    subject: "Subject",
    selectSubject: "Select a subject",
    reservation: "Reservation",
    customServices: "Custom Services",
    partnership: "Partnership",
    other: "Other",
    message: "Message",
    messagePlaceholder: "Your message",
//     sending: "Sending...",
    sendMessageButton: "Send Message",
    contactFormSent: "Your message has been sent!",
    ourContactDetails: "Our Contact Details",
//     address: "Address",
    openingHours: "Opening Hours",
    openingHoursDetails: "Monday - Friday: 8:00am - 6:00pm",
    loadingMap: "Loading map...",
    bookAppointment: "Book an appointment",
    appointmentDesc: "Our advisors are available for personalized appointments. Book your slot online or contact us by phone.",
    bookOnline: "Book Online",
    callNow: "Call Now",
    bookYourAppointment: "Book your appointment",
    close: "Close",
    calendlyWidget: "Calendly widget here (integration pending)",
    faqTitle: "Frequently Asked Questions",
    faqSectionTitle: "Frequently Asked Questions",
    faqQ1: "How do I book a stay?",
    faqA1: "You can book directly on our site or contact us via the form.",
    faqQ2: "What payment methods do you accept?",
    faqA2: "We accept credit cards, bank transfers, and cash at the agency.",
    faqQ3: "Do you offer group deals?",
    faqA3: "Yes, we have special offers for groups and agencies.",
    faqQ4: "Can I cancel or modify my reservation?",
    faqA4: "Yes, depending on the offer conditions. Contact us for more details.",
    faq1Question: "How do I book a stay?",
    faq1Answer: "You can book directly on our site or contact us via the form.",
    faq2Question: "What payment methods do you accept?",
    faq2Answer: "We accept credit cards, bank transfers, and cash at the agency.",
    faq3Question: "Do you offer group deals?",
    faq3Answer: "Yes, we have special offers for groups and agencies.",
    faq4Question: "Can I cancel or modify my reservation?",
    faq4Answer: "Yes, depending on the offer conditions. Contact us for more details.",
    startChat: "Start Chat",
    businessHours: "Monday - Friday: 9:00am - 6:00pm",
    responseTime: "Response within 24 hours",
//     searchHelp: "Search for help...",
    readyToPlan: "Ready to plan your stay?",
    readyToPlanDesc: "Our Touristic Palace team is ready to help you for an unforgettable experience in Morocco.",
    discoverOurStays: "Discover our stays",
    // Login Page
    loginTitle: "Sign in to Your Account",
    loginWelcomeTitle: "Welcome back!",
    loginWelcomeSubtitle: "Sign in to your account to continue your journey",
    loginButton: "Sign In",
    loggingIn: "Signing in...",
    loginError: "Failed to sign in. Please check your credentials.",
    googleLoginError: "Google sign-in failed. Please try again.",
    googleLoginFailed: "Google sign-in failed.",
    noAccountPrompt: "No account yet?",
    createAccount: "Create an account",
    or: "or",
    emailLabel: "Email address",
    phoneLabel: "Phone number",
    noAccount: "No account? Register",
    // Register Page
    registerTitle: "Create an Account",
    registerWelcomeTitle: "Join us!",
    registerWelcomeSubtitle: "Create your account and discover the authenticity of Morocco",
    username: "Username",
    usernamePlaceholder: "Your username",
    password: "Password",
    passwordPlaceholder: "Your password",
    confirmPassword: "Confirm Password",
    confirmPasswordPlaceholder: "Confirm your password",
    registerButton: "Register",
    registering: "Registering...",
    registerSuccess: "Registration successful. You can now sign in.",
    registerErrorPrefix: "Registration failed. ",
    registerError: "Failed to register. Please try again.",
    passwordMismatch: "Passwords do not match",
    passwordsMatch: "Passwords match",
    passwordComplexity: "Password must be at least 6 characters with an uppercase, lowercase, and number",
    phoneRequired: "Phone number is required",
    pleaseRetry: "Please try again.",
    googleLoginSuccess: "Google sign-in successful.",
    createMyAccount: "Create my account",
    alreadyRegisteredPrompt: "Already registered?",
    pwdRuleLength: "At least 6 characters",
    pwdRuleUpper: "One uppercase letter",
    pwdRuleLower: "One lowercase letter",
    pwdRuleNumber: "One number",
    alreadyRegistered: "Already registered? Sign in",
    // Process Section (Services)
    processTitle: "Our Process",
    processDesc: "A seamless process to plan your perfect Moroccan adventure",
    search: "Search",
    searchDesc: "Search for your preferred service, from Riads to guided tours, using our intuitive filters",
    select: "Select",
    selectDesc: "Choose from our curated selection of authentic Moroccan experiences tailored to your needs",
    book: "Book",
    bookDesc: "Secure your booking with our seamless process and flexible payment options",
    enjoy: "Enjoy",
    enjoyDesc: "Experience Morocco’s magic with confidence, supported by our 24/7 local team",
    //location
//     carRentalTitle: "Car Rental in Morocco",
    carRentalDesc: "Explore Morocco at your own pace with our reliable and affordable car rental services",
//     pickupLocation: "Pickup Location",
    pickupDate: "Pickup Date",
    returnDate: "Return Date",
//     carType: "Car Type",
//     allTypes: "All Types",
    economy: "Economy",
    suv: "SUV",
    luxury: "Luxury",
    van: "Van",
    searchCars: "Search Cars",
    noCarsFound: "No cars found matching your criteria",
    day: "day",
    rentNow: "Rent Now",
    reserveCar: "Reserve",
    pricePerDay: "Price per day",
//     total: "Total",
//     comments: "Comments / Special Requests",
//     confirmReservation: "Confirm Reservation",
//     cancel: "Cancel",
    errorFetchingCars: "Error loading car rentals",
//     reservationSuccess: "Reservation successful!",
//     reservationError: "Error making reservation",
//     tryAgain: "Try Again",
//     bookingProcessTitle: "Booking Process",
    carRentalProcess: "Rent Your Car with Ease",
    carRentalProcessDesc: "Follow these simple steps to rent a car for your Moroccan adventure",
    //circuit
    reviews: "avis",
//     perPerson: "par personne",
    aboutCircuit: "À propos de ce circuit",
//     highlights: "Points forts",
    included: "Ce qui est inclus",
    transport: "Transport",
    accommodation: "Hébergement",
    guidedTour: "Visite guidée",
    activities: "Activités",
//     startDate: "Date de départ",
//     numberOfPeople: "Nombre de personnes",
    travelerInfo: "Informations des voyageurs",
    traveler: "Voyageur",
//     lastName: "Nom",
//     firstName: "Prénom",
    dateOfBirth: "Date de naissance",
    nationality: "Nationalité",
    passportNumber: "Numéro de passeport",
    passportExpiry: "Date d'expiration du passeport",
//     comments: "Commentaires / Demandes spéciales",
//     pricePerPerson: "Prix par personne",
//     total: "Total",
//     confirmReservation: "Confirmer la réservation",
//     cancel: "Annuler",
    availableYearRound: "Disponible toute l'année",
    idealFor: "Idéal pour",
    allTravelers: "Tous types de voyageurs",
//     freeCancellation: "Annulation gratuite jusqu'à 7 jours avant le départ",
    backToCircuits: "Retour aux circuits",
    errorFetchingCircuit: "Erreur lors du chargement des détails du circuit",
    circuitNotFound: "Circuit introuvable",
//     reservationSuccess: "Réservation effectuée avec succès ! Redirection vers vos réservations...",
//     reservationError: "Erreur lors de la réservation",
//     bookingProcessTitle: "Processus de réservation",
    bookingProcess: "Planifiez votre circuit en toute simplicité",
    bookingProcessDesc: "Suivez ces étapes simples pour réserver votre aventure marocaine parfaite",
    selectDates: "Sélectionner les dates",
    selectDatesDesc: "Choisissez votre date de départ pour le circuit",
    //Guided Tours
//     guidedToursTitle: "Guided Tours in Morocco",
    guidedToursDesc: "Discover Morocco’s rich history and culture with our expert-guided tours",
//     location: "Location",
//     date: "Date",
//     tourType: "Tour Type",
//     allTypes: "All Types",
    cultural: "Cultural",
    historical: "Historical",
    nature: "Nature",
    adventure: "Adventure",
    enterCity: "Enter a city",
    searchTours: "Search Tours",
    noToursFound: "No tours found matching your criteria",
    perPerson: "person",
    bookNow: "Book Now",
    reserveTour: "Reserve",
    pricePerPerson: "Price per person",
    numberOfPeople: "Number of People",
    comments: "Comments / Special Requests",
    confirmReservation: "Confirm Reservation",
//     cancel: "Cancel",
    errorFetchingTours: "Error loading guided tours",
    reservationSuccess: "Reservation successful!",
    reservationError: "Error making reservation",
    tryAgain: "Try Again",
//     highlights: "Highlights",
    bookingProcessTitle: "Booking Process",
    tourBookingProcess: "Book Your Guided Tour with Ease",
    tourBookingProcessDesc: "Follow these simple steps to explore Morocco with expert guides",
    //Pro
     proDashboard: "Professional Dashboard",
    proDashboardDesc: "Manage your travel offerings, bookings, and client communications with ease",
    listings: "Listings",
    bookings: "Bookings",
    messages: "Messages",
    analytics: "Analytics",
    createListing: "Create Listing",
    createListingDesc: "Add your hotels, circuits, cars, or tours to attract clients",
    manageBookings: "Manage Bookings",
    manageBookingsDesc: "Review and update booking statuses to keep clients informed",
    engageClients: "Engage Clients",
    engageClientsDesc: "Respond to client inquiries and build lasting relationships",
    hotel: "Hotel",
    circuit: "Circuit",
    car: "Car Rental",
    tour: "Guided Tour",
    type: "Type",
    title: "Title",
    description: "Description",
    price: "Price (€)",
    location: "Location",
    create: "Create",
    cancel: "Cancel",
    published: "Published",
    draft: "Draft",
    publish: "Publish",
    unpublish: "Unpublish",
    noListings: "No listings found. Create one to get started",
    client: "Client",
    date: "Date",
    total: "Total",
    pending: "Pending",
    confirmed: "Confirmed",
    canceled: "Canceled",
    noBookings: "No bookings found",
    from: "From",
    noMessages: "No messages found",
    messageMarkedRead: "Message marked as read",
    totalBookings: "Total Bookings",
    revenue: "Revenue",
    pendingBookings: "Pending Bookings",
    errorFetchingProfile: "Error verifying user status",
    errorFetchingData: "Error loading professional data",
    errorCreatingListing: "Error creating listing",
    errorUpdatingListing: "Error updating listing",
    errorDeletingListing: "Error deleting listing",
    errorUpdatingBooking: "Error updating booking",
    errorUpdatingMessage: "Error updating message",
    listingCreated: "Listing created successfully",
    listingUpdated: "Listing status updated",
    listingDeleted: "Listing deleted successfully",
    bookingUpdated: "Booking status updated",
    notProUser: "Access restricted to professional users",
    backToHome: "Back to Home",
    confirmDelete: "Are you sure you want to delete this listing?",
    proProcessTitle: "How It Works",
    proProcess: "Manage Your Business with Ease",
    proProcessDesc: "Follow these simple steps to grow your travel business in Morocco",
    //Edit Listing
    editListing: "Edit Listing",
    editListingDesc: "Update your listing details to attract more clients",
    amenities: "Amenities",
//     itinerary: "Itinerary",
    features: "Features",
    highlights: "Highlights",
    addAmenity: "Add an amenity (e.g., Wi-Fi)",
    addItinerary: "Add an itinerary item (e.g., Day 1: Marrakech)",
    addFeature: "Add a feature (e.g., Air Conditioning)",
    addHighlight: "Add a highlight (e.g., Visit Medina)",
    saveChanges: "Save Changes",
    fillAllFields: "Please fill all required fields",
    positivePrice: "Price must be a positive number",
    errorFetchingListing: "Error loading listing data",
    backToDashboard: "Back to Dashboard",
    
    // About Page
    aboutPageTitle: "About Palais Touristique",
    aboutPageSubtitle: "Your trusted partner for authentic Moroccan experiences",
    ourStory: "Our Story",
    ourStoryDesc: "Founded with a passion for showcasing Morocco's rich culture and heritage,Palais Touristique has been creating unforgettable travel experiences for visitors from around the world.",
    ourMission: "Our Mission",
    ourMissionDesc: "To provide authentic, personalized, and memorable travel experiences that connect our guests with the true essence of Morocco.",
    ourValues: "Our Values",
    ourValuesDesc: "We believe in authenticity, excellence, and creating lasting memories through genuine cultural exchanges.",
    
    // Press Page
    pressPageTitle: "Press & Media",
    pressPageSubtitle: "Latest news and media coverage aboutPalais Touristique",
    pressReleases: "Press Releases",
    mediaCoverage: "Media Coverage",
    mediaInquiries: "Media Inquiries",
    mediaInquiriesDesc: "For press inquiries, please contact our media relations team.",
    
    // Blog Page
    blogPageTitle: "Travel Blog",
    blogPageSubtitle: "Discover Morocco through our stories and travel guides",
    readMore: "Read More",
    
    // Help Page
    helpPageTitle: "Help Center",
    helpPageSubtitle: "Find answers to your questions and get support",
    searchHelp: "Search for help...",
    frequentlyAsked: "Frequently Asked Questions",
    liveChat: "Live Chat",
    liveChatDesc: "Chat with our support team in real-time",
    phoneSupport: "Phone Support",
    phoneSupportDesc: "Call us for immediate assistance",
    emailSupport: "Email Support",
    emailSupportDesc: "Send us an email and we'll respond within 24 hours",
    
    // Cancellation Page
    cancellationPageTitle: "Cancellation Policy",
    cancellationPageSubtitle: "Understanding our cancellation terms and procedures",
    cancellationPolicy: "Cancellation Policy",
    cancellationPolicies: "Cancellation Policies",
    hotelReservations: "Hotel Reservations",
    hotelCancellation: "Réservations d'Hôtel",
    hotelCancellationDesc: "Free cancellation up to 24 hours before check-in",
    hotelFreeCancel: "Free cancellation up to 24 hours before check-in",
    hotelPartialRefund: "50% refund between 24-48 hours before check-in",
    hotelNoRefund: "No refund less than 24 hours before check-in",
    circuitTours: "Tours & Circuits",
    tourCancellation: "Tours & Circuits",
    tourCancellationDesc: "Free cancellation up to 7 days before departure",
    toursFreeCancel: "Free cancellation up to 7 days before departure",
    toursPartialRefund: "50% refund between 3-7 days before departure",
    toursNoRefund: "No refund less than 3 days before departure",
    carRentals: "Car Rentals",
    carCancellation: "Location de Voiture",
    carCancellationDesc: "Free cancellation up to 48 hours before pickup",
    carFreeCancel: "Free cancellation up to 48 hours before pickup",
    carPartialRefund: "50% refund between 24-48 hours before pickup",
    carNoRefund: "No refund less than 24 hours before pickup",
    guidedFreeCancel: "Free cancellation up to 24 hours before tour",
    guidedPartialRefund: "50% refund between 12-24 hours before tour",
    guidedNoRefund: "No refund less than 12 hours before tour",
    importantNotice: "Important Notice",
    importantNoticeDesc: "Please read our cancellation policies carefully before booking. Refund processing may take 5-10 business days.",
    freeCancellation: "Free Cancellation",
    partialRefund: "Partial Refund",
    noRefund: "No Refund",
    howToCancel: "How to Cancel",
    howToCancelDesc: "You can cancel your booking through your account or by contacting our support team.",
    step1Title: "Login to Your Account",
    step1Desc: "Access your booking dashboard through your account",
    step2Title: "Find Your Booking",
    step2Desc: "Locate the reservation you want to cancel",
    step3Title: "Request Cancellation",
    step3Desc: "Click cancel and follow the confirmation steps",
    needHelpTitle: "Need Help with Cancellation?",
    needHelpDesc: "Our support team is here to assist you with any orientation or cancellation questions.",
    contactSupport: "Contact Support",
    safetyPageTitle: "Safety & Security",
    safetyPageSubtitle: "Your safety is our top priority",
    safetyMeasures: "Safety Measures",
    safetyMeasuresDesc: "We implement comprehensive safety protocols for all our services",
    travelTips: "Travel Safety Tips",
    travelTipsDesc: "Essential safety guidelines for traveling in Morocco",
    verifiedPartners: "Verified Partners",
    verifiedPartnersDesc: "All our hotels, transport providers, and tour guides are thoroughly vetted and certified.",
    professionalGuides: "Professional Guides",
    professionalGuidesDesc: "Our licensed tour guides are trained in safety protocols and emergency procedures.",
    safeLocations: "Safe Locations",
    safeLocationsDesc: "We only operate in safe, tourist-friendly areas with proper infrastructure and security.",
    support247: "24/7 Support",
    support247Desc: "Our emergency support team is available around the clock for any assistance you need.",
    emergencyContacts: "Emergency Contacts",
    emergencyContactsDesc: "Save these numbers in your phone before traveling. In case of emergency, call the appropriate service immediately.",
    healthInfo: "Health & Medical",
    beforeYouTravel: "Before You Travel",
    duringYourStay: "During Your Stay",
    
    // CGV Page
    cgvTitle: "Terms of Online Sales",
    cgvPreamble: "1. Preamble",
    cgvPreambleContent: "The following online sales terms govern all transactions established through Palais Touristique web site. Any transaction processed through this web site assumes the unconditional and irrevocable acceptance of these conditions by the customer.",
    cgvPurpose: "2. Purpose",
    cgvPurposeContent: "These terms are intended to define the rights and obligations of the parties in the context of the online sales done via Palais Touristique web site.",
    cgvSales: "3. Sales",
    cgvSalesContent: "The customer connects to Palais Touristique web site and selects the items that he wishes to buy. He then fills his identity information, accepts the terms and clicks on the “Pay” button. The customer is thus redirected to the Centre Monétique Interbancaire online secure payment platform where he completes his payment information and validates the payment.",
    cgvPaymentMethods: "4. Payment Methods",
    cgvPaymentMethodsContent: "To pay on Internet by credit card, the customer is called to enter his payment card credentials on the secure payment page. When the transaction is accepted by the bank, the settlement to debit his account is made in the working-day following the date of the transaction confirmation.\n\nThe bank cards accepted for online payment are Visa and Mastercard. All transactions are carried out exclusively in Moroccan dirham (MAD).\n\nOnline payment by bank card is secured by the Centre Monétique Interbancaire (CMI), which provides a fully secure payment service. Each transaction is protected by the 3-D Secure protocol, which authenticates the cardholder with their issuing bank before the payment is validated.\n\nThe bank card details (number, expiry date, security code) are entered directly on the CMI secure payment page: they are never seen, processed or stored by Palais Touristique. In the event of cancellation, non-performance or refund, the corresponding amount is credited back to the bank card used for the initial payment.\n\nThe customer guarantees Palais Touristique web site that he is fully authorised to use the chosen bank card and that he has the funds required when validating the payment.",
    cgvPrivacy: "5. Data Privacy",
    cgvPrivacyContent: "The information requested from the customer during the online payment are required to process the online transaction. They are treated confidentially. The customer has the right to consult or rectify his personal data.",
    cgvProof: "6. Proof of payment",
    cgvProofContent: "The data stored on the Centre Monétique Interbancaire online platform for the account of the Palais Touristique web site are considered as proof of payment for the online transaction made by the customer.",
    
    // Secure Payment Page
    securePaymentTitle: "Secure Payment",
    securePaymentDesc: "Your transactions are secured via the CMI platform and protected by 3D Secure.",
    threeDSecure: "3D Secure (Verified by Visa / Mastercard SecureCode) adds a layer of security during payment.",
    
    // Footer Extras
    securedByCMI: "Secured by CMI",
    builtWithCare: "Built by KYBOHO",
    emailUs: "Email Us",
    callUs: "Call Us",
    footerLocation: "Location",
    footerRights: "All rights reserved",
    // =============================
// Stay (Sejour) Page
// =============================
sejourTitle: "Stay & Accommodation",
sejourSubtitleNew:
  "Submit your request (hotel/riad) using the form. Our team will propose the best offer and send you a secure payment link.",

// Voice (STT)
sejourVoiceTitle: "Voice dictation (Stay) 🎙️",
sejourAutofillBtn: "✨ Autofill form",
sejourSpeakFirst: "Speak first, then click Autofill.",
sejourTranscriptionPlaceholder: "Transcription will appear here...",
sejourVoiceHint: "Tip: say “arrival on … departure on … budget … services wifi parking …”.",

// Sections
sejourInfoTitle: "Stay information",
sejourServicesTitle: "Desired services in the accommodation",
sejourPersonalInfoTitle: "Personal information",
sejourCgvTitle: "Terms / Payment",
sejourSubmitHint:
  "After submission, an agent will process your request, select the best option, set the final price, and email you a secure payment link.",

// Form labels
sejourCityLabel: "Desired city *",
sejourCityPlaceholder: "e.g., Fez, Rabat, Marrakech...",
sejourGuestsLabel: "Number of guests *",
sejourGuestOne: "guest",
sejourGuestsMany: "guests",

sejourArrivalLabel: "Check-in date *",
sejourDepartureLabel: "Check-out date *",

sejourStarsLabel: "Category (stars)",
sejourStarsAll: "All",
sejourStarsHint:
  "Our agent will propose the most suitable accommodation depending on availability.",

sejourBudgetLabel: "Budget per night (MAD) *",
sejourMin: "Min",
sejourMax: "Max",
sejourBudgetHint: "Provide a realistic range to speed up processing.",

// Services / discount
sejourDiscountLabel: "I want a discounted offer if available",

// Personal info fields
sejourFullNameLabel: "Full name *",
sejourFullNamePlaceholder: "e.g., Full name",
sejourEmailLabel: "Email *",
sejourEmailAccountLabel: "Email (account)",
sejourEmailAccountHint: "This email is linked to your account and cannot be changed here.",
sejourPhoneLabel: "Phone *",
sejourPhonePlaceholder: "e.g., +212 6xx xx xx xx",
sejourAddressLabel: "Address *",
sejourAddressPlaceholder: "e.g., district, street, city...",

// CGV / payment
sejourAcceptText1: "I have read and accept the",
sejourAcceptCgvLink: "Terms and Conditions",
sejourAcceptText2: "as well as the payment terms via CMI.",
sejourSecurePayment: "Secure payment:",
sejourPaymentInfoLink: "View CMI / Visa / MasterCard / 3DS information",
sejourMustAccept: "To submit, you must first accept the terms (CMI/CGV).",

// Buttons
sejourSending: "Sending...",
sejourSubmitBtn: "Submit my request",
sejourAnotherRequest: "Make another request",

// Success block
sejourSuccessTitle: "Request sent successfully!",
sejourSuccessDesc:
  "We received your stay request. Our agent will review it and contact you by email with an offer and a payment link.",

// Datepicker
// dpPlaceholder: "dd/mm/yyyy",
// dpClear: "Clear",
// dpToday: "Today",
// dpMon: "Mon",
// dpTue: "Tue",
// dpWed: "Wed",
// dpThu: "Thu",
// dpFri: "Fri",
// dpSat: "Sat",
// dpSun: "Sun",
// 
// // Validation / errors
errCityRequired: "Please enter the city.",
errArrivalRequired: "Please select the check-in date.",
errDepartureRequired: "Please select the check-out date.",
errDepartureAfterArrival: "Check-out must be after check-in.",
errFullNameRequired: "Please enter your full name.",
errEmailRequired: "Please enter your email.",
errPhoneRequired: "Please enter your phone number.",
errAddressRequired: "Please enter your address.",
errAcceptCgvRequired: "Please accept the payment terms (CMI/CGV).",
errPriceRange: "Please check the price range.",

// Gemini
// geminiError: "Gemini error",
// geminiNetworkError: "Network / server error (Gemini)",
// geminiAutofillSuccess: "Stay form filled from your voice ✅",
// 
// // =============================
// // Circuit Page
// // =============================
circuitTitle: "Tour Circuit Request",
circuitSubtitle: "Fill in the form and we will propose a tailor-made circuit.",

// Sections
tripInfo: "Trip information",
itinerary: "Stops (Itinerary)",
// personalInfo: "Personal information",
// paymentConditions: "Payment conditions (CMI)",
// 
// // Voice / STT
circuitVoiceTitle: "Voice dictation (Circuit) 🎙️",
circuitAutofillBtn: "✨ Autofill form",
circuitSpeakFirst: "Speak first, then click Autofill.",
circuitTranscriptPlaceholder: "Transcription will appear here...",
circuitVoiceHint:
  "Example: “Destination Fez, date 2026-01-12, duration 4 days, type family, budget 2000 to 4000, stops Rabat then Tangier…”",

// Fields (trip)
destination: "Destination",
// chooseCity: "Choose a city...",
travelDate: "Travel date",
duration: "Duration",
allDurations: "Choose...",
travelType: "Trip type",
allTypes: "Choose...",
budget: "Budget (optional)",
minPrice: "Min price",
maxPrice: "Max price",

// Values
day1: "1 day",
days2: "2 days",
days3: "3 days",
days4: "4 days",
days5: "5 days",
weekend: "Weekend",
week: "1 week",
days10: "10 days",
weeks2: "2 weeks",

typeSolo: "Solo",
typeCouple: "Couple",
typeFamily: "Family",
typeGroup: "Group",
typeFriends: "Friends",

// Stations
addStation: "Add a stop",
add: "Add",
stationsExample: "Example: Fez → Rabat → Larache → Asilah → Tangier",
stationPlaceholder: "e.g., Fez, Rabat, Larache...",

// Personal fields
// fullName: "Full name",
// fullNamePlaceholder: "e.g., Full name",
// emailLabel: "Email",
emailAccountLabel: "Email (account)",
emailAccountHint: "This email is linked to your account and cannot be changed here.",

// phonePlaceholder: "e.g., +212 6xx xx xx xx",
addressLabel: "Address",
// addressPlaceholder: "e.g., district, street, city...",
// 
// // CMI
// cmiAcceptText:
//   "I accept the payment terms and authorize generating a CMI payment link to finalize my reservation.",
cmiMustAcceptHint: "To enable the button, please accept the payment terms.",

// Buttons / states
// sending: "Sending...",
// sendRequest: "Send request",
// 
// // Messages
circuitRequiredError: "Please fill in required fields and accept the payment terms.",
circuitSuccessMsg:
  "Your circuit request has been sent successfully. We will contact you soon.",
circuitSendError: "Error while sending the request. Please try again.",

// Datepicker (reused)
// dpPlaceholder: "dd/mm/yyyy",
// dpClear: "Clear",
// dpToday: "Today",
// dpMon: "Mon",
// dpTue: "Tue",
// dpWed: "Wed",
// dpThu: "Thu",
// dpFri: "Fri",
// dpSat: "Sat",
// dpSun: "Sun",
// 
// // Gemini
// geminiError: "Gemini error",
// geminiNetworkError: "Network / server error (Gemini)",
// geminiAutofillSuccess: "Circuit form filled from your voice ✅",
// 
// // =============================
// // Transport Page
// // =============================
transportTitle: "Tourist Transport",
transportSubtitle: "Transfers, airport shuttles and private hire with driver",

// Tabs
simpleTrip: "Simple Trip",
airportShuttle: "Airport Shuttle",
privateHire: "Private Hire",

// Form headers
requestTitle: "Request - Transport",
requestSubtitle: "Fill in the form and we will contact you quickly.",

// Voice / STT
transportVoiceTitle: "Voice dictation (Transport) 🎙️",
transportAutofillBtn: "✨ Autofill form",
transportSpeakFirst: "Speak first, then click Autofill.",
transportTranscriptPlaceholder: "Transcription will appear here...",
transportVoiceHint:
  "Say: “Trip from Fez to Rabat tomorrow at 2pm, 3 people…” / “Airport shuttle …” / “Private hire …”",

// Common fields
// chooseCity: "Choose a city",
departureCity: "Departure city",
arrivalCity: "Arrival city",
departureDate: "Date",
departureTime: "Time",
guests: "Guests",
passengers: "Passengers",

// Shuttle
airport: "Airport",
allAirports: "Choose an airport",

// Disposition
// pickupLocation: "Pickup location",
pickupLocationPlaceholder: "Address, hotel...",
// startDate: "Start date",
startTime: "Start time",
// endDate: "End date",
serviceType: "Service type",
byHour: "By hour",
halfDay: "Half-day",
fullDay: "Full day",
severalDays: "Several days",

// Personal info
// personalInfo: "Personal information",
personalInfoSubtitle: "This information helps us contact you.",
// fullName: "Full name",
fullNamePlaceholder: "e.g., Full name",
// email: "Email",
// phone: "Phone",
// address: "Address",
emailPlaceholder: "you@example.com",
phonePlaceholder: "e.g., +212 6xx xx xx xx",
addressPlaceholder: "City, district, hotel...",

// Payment / conditions
paymentConditions: "Terms & Payment",
paymentConditionsSubtitle: "You must accept the terms to send your request.",
mustAccept: "⚠️ Please check the box to enable sending.",
cmiAcceptText: "I accept CMI payment terms and the service charter.",

// Buttons / states
// sending: "Sending...",
sendRequest: "Send request",

// Validation messages
// vChooseDate: "Please choose a date.",
vChooseTime: "Please choose a time.",
vInvalidPeople: "Invalid number of people.",
// vFullName: "Please enter your full name.",
// vEmail: "Please enter your email.",
// vPhone: "Please enter your phone number.",
// vAddress: "Please enter your address.",
vAccept: "Please accept the terms (CMI/Charter).",
vDepartCity: "Please choose the departure city.",
vArriveCity: "Please choose the arrival city.",
vDifferentCities: "Departure and arrival must be different.",
vAirport: "Please choose an airport.",
vPickup: "Please enter the pickup location.",
// vEndDate: "Please choose the end date.",
// vEndAfterStart: "End date must be after start date.",
// 
// // Toast submit
transportSent: "✅ Request sent! Reference:",
transportError: "Error while sending the request. Please try again.",

// Datepicker shared
dpPlaceholder: "dd/mm/yyyy",
dpClear: "Clear",
dpToday: "Today",
dpMon: "Mon",
dpTue: "Tue",
dpWed: "Wed",
dpThu: "Thu",
dpFri: "Fri",
dpSat: "Sat",
dpSun: "Sun",

// Gemini
// geminiError: "Gemini error",
// geminiNetworkError: "Network / server error (Gemini)",
// geminiAutofillSuccess: "Transport form filled from your voice ✅",
// 
// // =============================
// // Location Page (Car rental)
// // =============================
carRentalTitle: "Car Rental",
carRentalSubtitleNew:
  "Submit your request using the form. Our team will suggest a suitable vehicle, confirm the final price, and send you a secure CMI payment link.",

// Sections
rentalInfo: "Rental information",
rentalPreferences: "Details / preferences",
// personalInfo: "Personal information",
// paymentCgvTitle: "Terms & Payment",
// 
// // STT
locationVoiceTitle: "Voice dictation (Car rental) 🎙️",
locationAutofillBtn: "✨ Autofill form",
locationSpeakFirst: "Speak first, then click Autofill.",
locationTranscriptPlaceholder: "Transcription will appear here...",
locationVoiceHint:
  "Tip: say “pickup at … start … return … SUV … automatic … diesel … budget …”",

// Fields (rental)
pickupLocation: "Pickup location",
pickupLocationPh: "e.g., Fez airport, city center...",
// peopleCount: "Number of people",
startDate: "Start date",
endDate: "Return date",

carType: "Car type",
// any: "Any",
carEconomy: "Economy",
carSuv: "SUV",
carLuxury: "Luxury",
carVan: "Van / Minibus",

transmission: "Transmission",
auto: "Automatic",
manual: "Manual",

fuel: "Fuel",
diesel: "Diesel",
gasoline: "Gasoline",
hybrid: "Hybrid",
electric: "Electric",

budgetPerDay: "Daily budget (MAD)",
budgetMin: "Min",
budgetMax: "Max",
// budgetHint: "Provide a realistic range to speed up processing.",
// 
// // Preferences / comments
// discountWish: "I would like a discounted offer if available",
// commentsLabel: "Comments / special needs",
commentsPh: "e.g., baby seat, hotel delivery, automatic only...",

// Personal fields
// fullName: "Full name",
// fullNamePh: "e.g., Full name",
// email: "Email",
// emailAccount: "Email (account)",
// emailPh: "you@example.com",
// emailLockedHint: "This email is linked to your account and cannot be changed here.",
// phone: "Phone",
// phonePh: "e.g., +212 6xx xx xx xx",
// address: "Address",
// addressPh: "e.g., district, street, city...",
// 
// // CGV/CMI
// cgvTextPrefix: "I have read and accept the",
// cgvLinkText: "Terms & Conditions",
// cgvTextSuffix: "as well as CMI payment terms.",
// securePaymentLabel: "Secure payment:",
// securePaymentLink: "See CMI / Visa / MasterCard / 3DS information",
// mustAcceptCgv: "To send the request, you must accept the terms (CMI/T&C).",
afterSubmitHint:
  "After submitting, an agent will process your request, choose the most suitable car, set the final price and email you a secure payment link.",
// cmiFooter: "Final payment via secure CMI link (3DS)",
// 
// // Success screen
// successTitle: "Request sent successfully!",
successBody:
  "We have received your rental request. An agent will review it and contact you by email with an offer and a secure payment link.",
// successNewRequest: "Make another request",
// 
// // Buttons / states
// sending: "Sending...",
// submitRequest: "Submit my request",
// 
// // Validation / Toasts
vPickupLocation: "Please enter the pickup location.",
vStartDate: "Please choose the start date.",
vEndDate: "Please choose the return date.",
vEndAfterStart: "Return date must be after the start date.",
// vFullName: "Please enter your full name.",
// vEmail: "Please enter your email.",
// vPhone: "Please enter your phone number.",
// vAddress: "Please enter your address.",
// vBudgetRange: "Please check the budget range (min/max).",
// vAcceptCgv: "Please accept the payment terms (CMI/T&C).",
// 
locationSent: "Your rental request has been sent!",
// sendError: "Error while sending. Please try again.",
// 
// // Gemini
// geminiError: "Gemini error",
// geminiNetworkError: "Network / server error (Gemini)",
// geminiAutofillSuccess: "Car rental form filled from your voice ✅",
// 
// // =============================
// // Guided Tours
// // =============================
guidedToursTitle: "Guided tours",
guidedToursSubtitleNew:
  "Submit your request using the form. Our team will suggest the best tour, confirm the final price, and send you a secure CMI payment link.",

// Sections
guidedInfo: "Guided tour information",
guidedPreferences: "Details / preferences",
personalInfo: "Personal information",
paymentCgvTitle: "Terms & Payment",

// STT
guidedVoiceTitle: "Voice dictation (Guided tour) 🎙️",
guidedAutofillBtn: "✨ Autofill form",
speakFirst: "Speak first, then click Autofill.",
transcriptPlaceholder: "Transcription will appear here...",
guidedVoiceHint:
  "Tip: speak naturally. Chrome/Edge recommended. In production, HTTPS is required.",

// Fields
cityPlace: "City / place",
chooseCity: "Choose a city...",
specifyPlace: "Specify the place",
specifyPlacePh: "e.g., Volubilis, Ziz Valley...",
dateLabel: "Date",
tourType: "Tour type",
peopleCount: "Number of people",
durationHours: "Desired duration (hours)",
budgetTotal: "Total budget (MAD)",
minLabel: "Min",
maxLabel: "Max",
durationHint: "e.g., 2–4h for medina, 6–8h for an excursion.",
budgetHint: "Provide a realistic range to speed up processing.",

// Tour types
any: "Any",
tourCultural: "Cultural",
tourHistorical: "Historical",
tourNature: "Nature",
tourAdventure: "Adventure",

// Preferences
discountWish: "I would like a discounted offer if available",
commentsLabel: "Comments / special needs",
guidedCommentsPh: "e.g., French-speaking guide, accessible, private tour, points of interest...",

// Personal fields
fullName: "Full name",
fullNamePh: "e.g., Full name",
email: "Email",
emailAccount: "Email (account)",
emailPh: "you@example.com",
emailLockedHint: "This email is linked to your account and cannot be changed here.",
phone: "Phone",
phonePh: "e.g., +212 6xx xx xx xx",
address: "Address",
addressPh: "e.g., district, street, city...",

// CGV/CMI
cgvTextPrefix: "I have read and accept the",
cgvLinkText: "Terms & Conditions",
cgvTextSuffix: "as well as CMI payment terms.",
securePaymentLabel: "Secure payment:",
securePaymentLink: "See CMI / Visa / MasterCard / 3DS information",
mustAcceptCgv: "To send the request, you must accept the terms (CMI/T&C).",
afterSubmitGuidedHint:
  "After submitting, an agent will process your request, select the best offer, set the final price and email you a secure payment link.",
cmiFooter: "Final payment via secure CMI link (3DS)",

// Success screen
successTitle: "Request sent successfully!",
successGuidedBody:
  "We have received your guided tour request. An agent will review it and contact you by email with an offer and a secure payment link.",
successNewRequest: "Make another request",

// Buttons / states
// sending: "Sending...",
// submitRequest: "Submit my request",
// 
// // Validation / Toasts
vChooseCity: "Please choose the city / place.",
vChooseDate: "Please choose the date.",
vDurationRange: "Please check the duration range (min/max).",
vBudgetRange: "Please check the budget range (min/max).",
vFullName: "Please enter your full name.",
// vEmail: "Please enter your email.",
// vPhone: "Please enter your phone number.",
vAddress: "Please enter your address.",
vAcceptCgv: "Please accept the payment terms (CMI/T&C).",
vSpecifyOther: "Please specify the place (Other option).",

// Gemini
geminiError: "Gemini error",
geminiNetworkError: "Network / server error (Gemini)",
geminiAutofillSuccess: "Form filled from your voice ✅",

// Sent
guidedSent: "Your guided tour request has been sent!",
sendError: "Error while sending. Please try again.",


// =============================
// Agency Partnership
// =============================
agencyPartnershipTitle: "Agency Partnership",
agencyPartnershipSubtitle:
  "Are you an international travel agency? Partner with our Moroccan network to deliver outstanding services to your clients in Morocco.",
agencyProgramBadge: "Partner Program",
agencyBecomePartner: "Become a partner",
agencyBenefitsBadge: "Partner benefits",
agencyWhyChoosePrefix: "Why",
agencyWhyChooseHighlight: "choose us",
agencyStatPartners: "Partner agencies",
agencyStatCountries: "Countries represented",
agencyStatSatisfaction: "Satisfaction rate",
agencyStatResponse: "Response time",
agencyBenefit1Title: "Guaranteed growth",
agencyBenefit1Desc: "Increase your business volume with our Morocco network.",
agencyBenefit2Title: "Total reliability",
agencyBenefit2Desc: "Certified partner with high quality standards.",
agencyBenefit3Title: "Dedicated support",
agencyBenefit3Desc: "A personal account manager for each agency partner.",
agencyBenefit4Title: "Attractive commissions",
agencyBenefit4Desc: "Competitive margins that reward your loyalty.",
agencyHowToBecomePrefix: "How to become",
agencyHowToBecomeHighlight: "a partner",
agencyStep1Title: "Application",
agencyStep1Desc: "Fill in the form below",
agencyStep2Title: "Evaluation",
agencyStep2Desc: "Our team reviews your profile",
agencyStep3Title: "Collaboration",
agencyStep3Desc: "Start your partnership",
agencyTestimonial1Quote: "The best partner in Morocco. Impeccable service and ultra-fast responses.",
agencyTestimonial1Agency: "Voyages Horizon, France",
agencyTestimonial2Quote: "Thanks to Nouzha, we doubled our Morocco offering in one year. Very professional.",
agencyTestimonial2Agency: "Sol y Luna Travel, Spain",
agencyTestimonial3Quote: "Smooth collaboration, attractive commissions, and consistent quality. I recommend them.",
agencyTestimonial3Agency: "Wanderlust Tours, Germany",
agencyServiceTypeAccommodation: "Accommodation (Hotels/Riads)",
agencyServiceTypeCircuits: "Organized tours",
agencyServiceTypeTransport: "Tourist transport",
agencyServiceTypeGuides: "Tour guides",
agencyServiceTypeCarRental: "Vehicle rental",
agencyServiceTypeGuidedTours: "Guided visits",
agencyServiceTypeAdventure: "Adventure activities",
agencyServiceTypeEvents: "Events and MICE",
agencyServiceTypeTransfers: "Airport transfers",
agencyServiceTypeAssistance: "24/7 assistance",
agencyLanguageFrench: "French",
agencyLanguageEnglish: "English",
agencyLanguageSpanish: "Spanish",
agencyLanguageItalian: "Italian",
agencyLanguageGerman: "German",
agencyLanguagePortuguese: "Portuguese",
agencyLanguageArabic: "Arabic",
agencyLanguageBerber: "Berber",
agencySidebarImageAlt: "Morocco partnership",
agencySidebarJoinTitle: "Join our network",
agencySidebarJoinDesc: "150+ agencies already trust us",
agencySidebarWhatYouGet: "What you get",
agencySidebarBenefit1: "Dedicated partner dashboard",
agencySidebarBenefit2: "Guaranteed preferential rates",
agencySidebarBenefit3: "Multilingual support 7/7",
agencySidebarBenefit4: "Training on our products",
agencySidebarBenefit5: "Co-branded marketing",
agencySidebarBenefit6: "Fast payments",
agencySidebarQuestions: "Questions?",
agencySidebarQuestionsDesc: "Our sales team is available to help with any information you need.",

// Success screen
agencySuccessTitle: "Partnership request sent!",
agencySuccessBody:
  "We have received your request. Our sales team will review it and contact you shortly.",
agencyNewRequest: "New request",

// Sections
agencyInfoTitle: "Your agency information",
agencyServicesProvided: "Services you provide",
agencyTeamLanguages: "Languages spoken by your team",
agencyAgencyPresentation: "Agency presentation",
agencyRequiredServicesTitle: "Services needed in Morocco",
agencyAddService: "Add a service",
agencyContactTitle: "Main contact",

// Fields (agency)
agencyName: "Agency name",
agencyCountry: "Country of origin",
agencyWebsite: "Website",
agencyLicense: "License / registration number",
agencyAnnualClients: "Annual number of clients",
agencyCommission: "Desired commission (%)",
agencyEstimatedTurnover: "Estimated annual turnover (EUR)",
agencyMoroccoExperience: "Experience with Morocco",
agencyPresentationPlaceholder: "Introduce your agency, expertise, and values...",

// Annual clients options
selectOption: "Select...",
clientsLess100: "Less than 100 clients",
clients100_500: "100 - 500 clients",
clients500_1000: "500 - 1,000 clients",
clients1000_5000: "1,000 - 5,000 clients",
clientsMore5000: "More than 5,000 clients",

// Morocco experience options
expNone: "No experience",
expBeginner: "Beginner (less than 2 years)",
expIntermediate: "Intermediate (2-5 years)",
expExperienced: "Experienced (more than 5 years)",

// Required services block
serviceLabel: "Service",
serviceTypeRequired: "Service type",
serviceMonthlyVolume: "Estimated volume / month",
servicePeriod: "Preferred period",
serviceDetailedDesc: "Detailed description",
serviceDelete: "Delete",
serviceTypeSelect: "Select...",
serviceVolumePlaceholder: "e.g., 50 clients, 10 groups...",
serviceDescPlaceholder: "Describe your specific needs...",

// Period options
periodAllYear: "All year",
periodHighSeason: "High season only",
periodLowSeason: "Low season only",
periodOnDemand: "On demand",

// Contact fields
// firstName: "First name",
// lastName: "Last name",
// emailLabel: "Your email address",
// emailLabelRequired: "Your email address *",
// phoneNumber: "Phone number",
// firstNamePh: "Your first name",
// lastNamePh: "Your last name",
contactEmailPh: "e.g., contact@your-agency.com",
contactPhonePh: "e.g., +33 1 23 45 67 89",

// Submit
// sending: "Sending...",
agencySubmit: "Send partnership request",

// Toasts
agencySentOk: "Your partnership request has been successfully recorded!",
agencyGenericError: "An error occurred.",
agencyNetworkError: "An error occurred. Please try again later.",

// Validation messages
vAgencyName: "Agency name is required",
vAgencyCountry: "Country of origin is required",
vAgencyPresentation: "Presentation is required",
vAgencyServiceProvided: "Select at least one provided service",
vAgencyLanguage: "Select at least one spoken language",
vFirstName: "First name is required",
vLastName: "Last name is required",
vEmail: "Email is required",
vPhone: "Phone number is required",
vRequiredServiceTypePrefix: "Required service type is missing (Service ",
vRequiredServiceTypeSuffix: ")",

// =============================
// Custom Circuit
// =============================
customCircuitTitle: "Custom Tour",
customCircuitSubtitle:
  "Create your own personalized trip. We will organize everything to give you a unique experience.",
customProcessStepLabel: "Step",
customProcessStep1Title: "Trip brief",
customProcessStep1Desc: "Share your preferences, budget, and dates.",
customProcessStep2Title: "Custom design",
customProcessStep2Desc: "Our team builds an itinerary tailored to your profile.",
customProcessStep3Title: "Fast validation",
customProcessStep3Desc: "You receive a clear proposal with price and options.",
customTrustBanner: "Secure payment, human support, and a detailed proposal before validation.",
customAvgResponse: "Average response: 24h",
customInspirations: "Inspirations",
customWhyTailorTitle: "Why tailor-made?",
customWhyTailor1: "100% personalized itinerary",
customWhyTailor2: "Local expert guide included",
customWhyTailor3: "Accommodation of your choice",
customWhyTailor4: "Comfortable private transport",
customWhyTailor5: "Total flexibility",
customTestimonialQuote: "An unforgettable trip! The team created a circuit perfectly adapted to our wishes. From the desert to the mountains, every step was magical.",
customTestimonialCaption: "10-day circuit • Family",

// Success screen
customCircuitSuccessTitle: "Request sent successfully!",
customCircuitSuccessBody:
  "We have received your custom tour request. Our team will review it and contact you shortly.",
customCircuitNew: "Create another tour",

// Sections
customCircuitGeneralInfo: "General information",
customCircuitStepsTitle: "Your itinerary steps",
customCircuitAddStep: "Add a step",
customCircuitContactInfo: "Contact information",
customCircuitExtraInfo: "Specific requests or additional information",

// Fields
customCircuitTripTitle: "Tour title",
customCircuitTripTitlePh: "e.g., Authentic Morocco discovery",
customCircuitPeopleCount: "Number of people",
customCircuitStartDate: "Preferred start date",
customCircuitTotalDays: "Total duration (days)",
customCircuitAccommodation: "Preferred accommodation type",
customCircuitVehicle: "Vehicle type",
customCircuitBudget: "Approx. budget per person (€)",

customCircuitDescription: "Describe your ideal tour",
customCircuitDescriptionPh: "Describe the kind of experience you want...",

// Select options accommodation
accStandard: "Standard",
accComfort: "Comfort",
accLuxury: "Luxury",
accRiad: "Traditional riad",
accMixed: "Mixed",

// Select options vehicle
vehStandard: "Standard vehicle",
vehComfort: "Comfort vehicle",
veh4x4: "4x4",
vehMinibus: "Minibus",
vehLuxury: "Luxury vehicle",

// Step block
customCircuitStepLabel: "Step",
customCircuitDelete: "Delete",
customCircuitCity: "City",
customCircuitCityPh: "e.g., Marrakech",
customCircuitStayDays: "Duration (days)",
customCircuitActivities: "Desired activities",
customCircuitActivitiesPh: "e.g., Medina tour, hiking...",

// Contact fields
firstName: "First name",
lastName: "Last name",

emailLabelRequired: "Your email address *",
phoneNumber: "Phone number",
firstNamePh: "Your first name",
lastNamePh: "Your last name",
customCircuitEmailPh: "e.g., you@example.com",
customCircuitPhonePh: "e.g., +212 600 000000",

// Extra textarea
customCircuitExtraPh: "Share your special expectations, constraints, and preferences...",

// Submit
sending: "Sending...",
submitRequest: "Submit my request",

// Toasts / Validation
vCustomTitle: "Please enter a title.",
vCustomDescription: "Please describe your tour.",
vCustomStartDate: "Please select a start date.",
vCustomDuration: "Please enter a valid duration.",
vMissingEmail: "Missing email.",
customCircuitServerError: "Error while saving the request.",
customCircuitNetworkError: "An error occurred. Please try again later.",
customCircuitSentOk: "Your custom tour request has been successfully recorded!",
customCircuitBadge: "Tailor-made",
formErrorsTitle: "Please fix",
wizCircuit: "Your tour",
wizItinerary: "Itinerary",
wizContact: "Your details",
wizBack: "Back",
wizNext: "Next",
wizVisit: "Tour",
wizStay: "Stay",
wizTrip: "Trip",
wizCar: "Vehicle",
wizInfos: "Your details",
wizPayment: "Payment",
vSpecifyPlace: "Please specify the place.",
vTitle: "Please enter the tour title.",
vDateStep: "Please choose the start date.",
vDurationStep: "Please enter the duration.",
vDescStep: "The description must be at least 10 characters.",
vStep: "Add at least one step with a city.",
vNameStep: "Please enter your first and last name.",
vEmailStep: "Please enter your email.",
vPhoneStep: "Please enter your phone number.",


  },
  fr: {
    // Navigation
    home: "Accueil",
    services: "Services",
    navContact: "Contact",
    navPro: "Pro",
    navCustomCircuit: "Circuit sur mesure",
    adminLabel: "Admin",
    profileLabel: "Profil",
    langEnglish: "Anglais",
    langFrench: "Français",
    logoutConfirmTitle: "Confirmation",
    logoutConfirmMessage: "Êtes-vous sûr de vouloir vous déconnecter ?",
    destinations: "Destinations",
    about: "À Propos",
//     contact: "Contact",
//     // Section Hero
    heroTitle: "VOYAGES TOURISTIQUES AU MAROC\nPar Palais Touristique",
    heroSubtitle: "Vivez la culture marocaine authentique avec nos services de voyage complets",
    searchPlaceholder: "Où souhaitez-vous aller?",
    checkin: "Arrivée",
    checkout: "Départ",
//     guests: "Invités",
    guest: "Invité",
    searchButton: "Rechercher et Réserver",
    // Hero Tabs
    tabSejour: "Séjour",
    tabSejourShort: "Séjour",
    tabCircuit: "Circuit",
    tabCircuitShort: "Circuit",
    tabTransport: "Transport",
    tabTransportShort: "Transport",
    tabLocation: "Location de voiture",
    tabLocationShort: "Location",
    tabVisite: "Visite guidée",
    tabVisiteShort: "Visite",
    // Hero - Reserve button (per tab)
    reserve: "Réserver",
    reserveStay: "Réserver un séjour",
    reserveCircuit: "Réserver un circuit",
    reserveTransport: "Réserver un transport",
//     reserveCar: "Réserver une voiture",
//     reserveTour: "Réserver une visite",
//
    heroHint: "Astuce : choisissez un onglet puis cliquez sur Réserver pour accéder au formulaire correspondant.",
    stayCheckIn: "Arrivée",
    stayCheckOut: "Départ",
    carPickupDate: "Retrait",
    carReturnDate: "Retour",
    circuitTravelDate: "Date de voyage",
    transportDate: "Date de départ",
    visitDate: "Date de visite",
    heroPickDates: "Choisissez vos dates",
    heroPickDate: "Choisissez une date",

    // Services
    servicesTitle: "Nos Services",
    servicesSubtitle: "Tout ce dont vous avez besoin pour une aventure marocaine inoubliable",
    servicesHeroTitlePrefix: "Explorez les",
    servicesHeroTitleHighlight: "Merveilles",
    servicesHeroTitleSuffix: "du Maroc",
    servicesViewCircuitsCta: "Voir les circuits",
    servicesCustomRequestCta: "Demande sur mesure",
    servicesWhatWeOffer: "Ce que nous proposons",
    servicesPopularDestinationsBadge: "Destinations populaires",
    servicesDiscoverTitlePrefix: "Découvrez le",
    servicesDiscoverTitleHighlight: "Maroc",
    servicesJourneyTitlePrefix: "Votre",
    servicesJourneyTitleHighlight: "Parcours",
    servicesJourneyTitleSuffix: "avec Nouzha",
    servicesStepLabel: "Étape",
    servicesTrustSupportTitle: "Support 7j/7",
    servicesTrustSupportDesc: "Équipe locale réactive avant, pendant et après votre voyage.",
    servicesTrustSupportValue: "< 15 min",
    servicesTrustPaymentTitle: "Paiement sécurisé",
    servicesTrustPaymentDesc: "Transactions protégées via passerelles de paiement vérifiées.",
    servicesTrustPaymentValue: "CMI + Stripe",
    servicesTrustCustomTitle: "Offres sur mesure",
    servicesTrustCustomDesc: "Expériences adaptées à votre style, votre rythme et votre budget.",
    servicesTrustCustomValue: "100% flexible",
    servicesStatsClientsLabel: "Clients satisfaits",
    servicesStatsCircuitsLabel: "Circuits proposés",
    servicesStatsCitiesLabel: "Villes couvertes",
    servicesStatsRatingLabel: "Note moyenne",
    serviceWifi: "Wifi",
    serviceParking: "Parking",
    serviceRestaurant: "Restaurant",
    serviceSpa: "Spa",
    servicePool: "Piscine",
    servicePrivateBeach: "Plage privée",
    serviceGolf: "Golf",
    serviceSauna: "Sauna",
    riads: "Riads & Hôtels",
    riadsDesc: "Riads marocains authentiques et hôtels de luxe dans les villes impériales",
    circuits: "Circuits & Tours",
    circuitsDesc: "Visites guidées à travers l'Atlas, le Sahara et les médinas anciennes",
    carRental: "Location de Voiture",
//     carRentalDesc: "Explorez le Maroc à votre rythme avec nos véhicules fiables",
//     transport: "Transport Touristique",
    transportDesc: "Transport confortable entre les villes et sites touristiques",
    guidedTours: "Visites Guidées",
//     guidedToursDesc: "Guides locaux experts pour vous montrer les trésors cachés",
//     // Why Choose Us
    whyChooseTitle: "Pourquoi Choisir Palais Touristique?",
    whyChooseSubtitle: "Votre partenaire de confiance pour des expériences marocaines authentiques",
    localExpertise: "Expertise Locale",
    localExpertiseDesc: "Guides natifs avec une connaissance approfondie de la culture marocaine",
    bestPrices: "Meilleurs Prix",
    bestPricesDesc: "Tarifs compétitifs sans frais cachés et garantie de prix",
//     support: "Support 24/7",
    supportDesc: "Assistance 24h/24 dans plusieurs langues",
    authenticity: "Expériences Authentiques",
    authenticityDesc: "Immersion culturelle authentique avec les familles locales",
    // Destinations
    destinationsTitle: "Destinations Populaires",
    destinationsSubtitle: "Découvrez les lieux les plus enchanteurs du Maroc",
    marrakech: "Marrakech",
    marrakechDesc: "La Ville Rouge avec ses souks animés et palais historiques",
    fez: "Fès",
    fezDesc: "La capitale culturelle avec la plus grande médina du monde",
    casablanca: "Casablanca",
    casablancaDesc: "Métropole moderne avec la magnifique Mosquée Hassan II",
    sahara: "Désert du Sahara",
    saharaDesc: "Camps dans le désert et randonnées à dos de chameau inoubliables",
    chefchaouen: "Chefchaouen",
    chefchaouenDesc: "La perle bleue nichée dans les montagnes du Rif",
    essaouira: "Essaouira",
    essaouiraDesc: "Charme côtier avec architecture portugaise et fruits de mer frais",
    // Testimonials
    testimonialsTitle: "Ce Que Disent Nos Voyageurs",
    testimonialsSubtitle: "Expériences réelles de vrais aventuriers",
    // CTA
    ctaTitle: "Prêt pour Votre Aventure Marocaine?",
    ctaSubtitle: "Rejoignez des milliers de voyageurs qui ont découvert le Maroc avec nous",
    startBooking: "Commencez Votre Voyage",
    downloadApp: "Télécharger l'App",
    // Footer
    company: "Entreprise",
    aboutUs: "À Propos",
    careers: "Carrières",
    press: "Presse",
    blog: "Blog",
    support: "Support",
    helpCenter: "Centre d'Aide",
//     contactUs: "Contactez-Nous",
    cancellation: "Annulation",
    safety: "Sécurité",
    legal: "Légal",
    privacy: "Politique de Confidentialité",
    terms: "Conditions d'Utilisation",
    cookies: "Politique des Cookies",
    rights: "Tous droits réservés",
    

    professionals: "Espace Professionnels",
    professionalsDesc:
      "Accédez à l’espace Pro pour les partenaires : agences, chauffeurs, guides et prestataires. Gérez vos demandes, disponibilités et collaboration en toute simplicité.",

    // Services page - generic CTA link on cards
    explore: "Explorer",
    // Legal Pages
    // Terms of Service
    termsTitle: "Conditions générales d'utilisation",
    termsPreambule: "Préambule",
    termsPreambuleContent: "Les présentes conditions générales d'utilisation (CGU) ont pour objet de définir les modalités et conditions d'utilisation du site PALAIS TOURISTIQUE, accessible à l'adresse www.PALAISTOURISTIQUE.ma, ainsi que les droits et obligations des utilisateurs du site.\n\nL'utilisation du site implique l'acceptation pleine et entière des présentes CGU. Ces conditions d'utilisation sont susceptibles d'être modifiées ou complétées à tout moment.",
    termsSiteAccess: "Accès au site",
    termsSiteAccessContent: "Le site est accessible gratuitement à tout utilisateur disposant d'un accès à internet. Tous les coûts afférents à l'accès au site, que ce soient les frais matériels, logiciels ou d'accès à internet sont exclusivement à la charge de l'utilisateur.\n\nL'accès à certaines sections du site peut nécessiter la création d'un compte utilisateur. Dans ce cas, l'utilisateur s'engage à fournir des informations exactes et à maintenir la confidentialité de ses identifiants de connexion.",
    termsServices: "Services proposés",
    termsServicesContent: "Des conseils personnalisés\nLa recherche de biens immobiliers à fort potentiel\nDes prestations de transformation (design, rénovation, ameublement)\nUn accompagnement administratif et financier\nUne plateforme de suivi client",
    termsUserCommitments: "Engagements de l'utilisateur",
    termsUserCommitmentsContent: "Ne pas perturber le bon fonctionnement du site\nNe pas utiliser les informations de manière frauduleuse\nRespecter les droits de propriété intellectuelle",
    termsIntellectualProperty: "Propriété intellectuelle",
    termsIntellectualPropertyContent: "Le site et l'ensemble de ses contenus (textes, visuels, logo, outils) sont protégés par les lois en vigueur sur la propriété intellectuelle. Toute reproduction, représentation, modification ou utilisation, totale ou partielle, sans autorisation préalable est strictement interdite.",
    termsLiabilityLimitation: "Limitation de responsabilité",
    termsLiabilityLimitationContent: "PALAIS TOURISTIQUE met en œuvre tous les moyens nécessaires pour fournir un service fiable, mais ne peut être tenu responsable d'éventuelles erreurs ou interruptions.",
    termsApplicableLaw: "Loi applicable et juridiction compétente",
    termsApplicableLawContent: "Les présentes CGU sont soumises au droit marocain. En cas de litige, seul le tribunal compétent de Casablanca sera compétent.",
    
    // Privacy Policy
    privacyTitle: "Politique de confidentialité",
    privacyIntroduction: "Introduction",
    privacyIntroductionContent: "La présente politique explique comment Palais Touristique collecte, utilise et protège vos données personnelles, conformément à la loi marocaine 09-08 sur la protection des données.",
    privacyDataCollection: "Collecte des données personnelles",
    privacyDataCollectionContent: "Nous collectons les données personnelles suivantes :\n\n• Données d'identité : nom, prénom, date de naissance\n• Données de contact : adresse e-mail, numéro de téléphone, adresse postale\n• Données de connexion : adresse IP, cookies, données de navigation\n• Données de transaction : informations de paiement, historique des réservations",
    privacyDataUse: "Utilisation des données personnelles",
    privacyDataUseContent: "Vos données personnelles sont utilisées pour :\n\n• Traiter vos réservations et demandes\n• Améliorer nos services\n• Vous envoyer des informations commerciales (avec votre consentement)\n• Respecter nos obligations légales",
    privacyDataSharing: "Partage des données",
    privacyDataSharingContent: "Nous ne vendons ni ne louons vos données personnelles à des tiers. Nous pouvons partager vos données avec :\n\n• Nos prestataires de services (hôtels, compagnies de transport)\n• Les autorités compétentes lorsque la loi l'exige\n• Nos partenaires techniques pour le fonctionnement du site",
    privacyDataSecurity: "Sécurité des données",
    privacyDataSecurityContent: "Nous mettons en place des mesures techniques et organisationnelles appropriées pour protéger vos données personnelles contre l'accès non autorisé, l'altération, la divulgation ou la destruction.",
    privacyYourRights: "Vos droits",
    privacyYourRightsContent: "Vous avez le droit de :\n\n• Accéder à vos données personnelles\n• Rectifier les données inexactes\n• Supprimer vos données dans certaines conditions\n• Vous opposer au traitement de vos données\n• La portabilité des données",
    privacyContact: "Contact",
    privacyContactContent: "Pour toute question concernant cette politique de confidentialité, vous pouvez nous contacter à : contact@palaisTouristique.ma",
    
    // Legal Mentions
    mentionsTitle: "Mentions Légales",
    mentionsCompliance: "Conformément à la loi n° 34-05 relative aux services de la société de l'information au Maroc.",
    mentionsSiteEditor: "Éditeur du site",
    mentionsSiteEditorContent: "PALAIS TOURISTIQUE\nSiège social : Fès, Maroc\nTéléphone : +212 651-913292\nEmail : contact@palaisTouristique.ma",
    mentionsIntellectualProperty: "Propriété intellectuelle",
    mentionsIntellectualPropertyContent: "L'ensemble du contenu de ce site (textes, images, vidéos, etc.) est protégé par les lois relatives à la propriété intellectuelle. Toute reproduction ou représentation, intégrale ou partielle, par quelque procédé que ce soit, faite sans le consentement du PALAIS TOURISTIQUE, est illicite.",
    
    // Cookie Policy
    cookiesTitle: "Politique de cookies",
    cookiesWhatIs: "Qu'est-ce qu'un cookie ?",
    cookiesWhatIsContent: "Un cookie est un petit fichier texte déposé sur votre terminal (ordinateur, tablette ou téléphone mobile) lors de votre visite sur notre site. Il nous permet de collecter des informations sur votre navigation et de vous proposer des services adaptés.",
    cookiesWeUse: "Les cookies que nous utilisons",
    cookiesWeUseContent: "Notre site utilise différents types de cookies :\n\n• Cookies techniques : nécessaires au fonctionnement du site et à l'utilisation des principales fonctionnalités\n• Cookies de mesure d'audience : pour établir des statistiques de fréquentation et d'utilisation du site\n• Cookies de personnalisation : pour adapter la présentation du site selon vos préférences\n• Cookies publicitaires : pour vous proposer des contenus adaptés à vos centres d'intérêt",
    cookiesManagement: "Gestion des cookies",
    cookiesManagementContent: "Vous pouvez à tout moment choisir de désactiver ces cookies. Votre navigateur peut également être paramétré pour vous signaler les cookies déposés et vous demander de les accepter ou non.\n\nVous pouvez accepter ou refuser les cookies au cas par cas ou bien les refuser systématiquement. Le paramétrage peut modifier vos conditions d'accès à nos services nécessitant l'utilisation de cookies.",
    cookiesBrowserConfig: "Comment configurer votre navigateur",
    cookiesBrowserConfigContent: "La configuration de chaque navigateur est différente. Consultez le menu d'aide de votre navigateur pour savoir comment modifier vos souhaits en matière de cookies.\n\n• Pour Google Chrome : Aide Google Chrome\n• Pour Mozilla Firefox : Aide Mozilla Firefox\n• Pour Microsoft Edge : Aide Microsoft Edge\n• Pour Safari : Aide Safari",
    cookiesRetention: "Durée de conservation des cookies",
    cookiesRetentionContent: "Les cookies sont conservés pour une durée maximale de 13 mois à compter de leur dépôt sur votre terminal.",
    
    // Common Legal Terms
    lastUpdated: "Dernière mise à jour :",
    // Buttons
    exploreOptions: "Explorer les Options",
    viewCircuits: "Voir les Circuits",
//     rentNow: "Louer Maintenant",
    bookTransport: "Réserver Transport",
    browseTours: "Parcourir les Tours",
    seeAll: "Voir Tous les Services",
    viewHotels: "Voir les Hôtels",
//     from: "à partir de",
//     
//     // Welcome message
    welcome: "Bienvenue",
    logout: "Déconnexion",
    
    // Additional translations
    discoverAllServices: "Découvrez tous nos services pour une expérience complète",
    seeMore: "Voir plus",
    
    // Badges
    popular: "Populaire",
//     cultural: "Culturel",
    modern: "Moderne",
//     adventure: "Aventure",
    unique: "Unique",
    coastal: "Côtier",
    
    // Testimonials
    testimonial1: "Une expérience absolument magique ! Le riad à Marrakech était à couper le souffle, et notre guide nous a montré des endroits que nous n'aurions jamais trouvés seuls.",
    testimonial2: "Organisation parfaite du début à la fin. Le tour du désert du Sahara a été le point culminant de notre voyage. Hautement recommandé !",
    testimonial3: "Expérience marocaine authentique avec un excellent service. Le cours de cuisine à Fès était incroyable !",
    testimonialsLoadErrorPrefix: "Impossible de charger les témoignages",
    testimonialsLoadErrorFallback: "Affichage des exemples.",
    homeCircuit1Title: "Atlas Prestige",
    homeCircuit1Subtitle: "Marrakech • Vallées berbères • Désert",
    homeCircuit1Duration: "7 jours",
    homeCircuit2Title: "Sahara Signature",
    homeCircuit2Subtitle: "Ouarzazate • Merzouga • Dunes dorées",
    homeCircuit2Duration: "5 jours",
    homeCircuit3Title: "Route Impériale",
    homeCircuit3Subtitle: "Fès • Meknès • Rabat • Casablanca",
    homeCircuit3Duration: "6 jours",
    homeCollection1Title: "Week-end depuis Fès",
    homeCollection1Subtitle: "Escapades courtes, confort premium",
    homeCollection1Duration: "2-3 jours",
    homeCollection2Title: "Désert Luxe",
    homeCollection2Subtitle: "Camp haut de gamme et ciel étoilé",
    homeCollection2Duration: "3-5 jours",
    homeCollection3Title: "Family Friendly",
    homeCollection3Subtitle: "Itinéraires souples pour familles",
    homeCollection3Duration: "4-7 jours",
    homePremiumBadge: "Collection Premium",
    homePremiumTitle: "Circuits visuels, style agence haut de gamme",
    homePremiumDescription: "Vivez l'expérience marocaine ultime avec nos circuits soigneusement élaborés.",
    homePremiumTrustLine: "Des centaines de voyageurs nous ont déjà fait confiance.",
    homePremiumSeeAll: "Tout voir",
    homeCollectionsBadge: "Collections",
    homeCollectionsTitle: "Inspiration du moment",
    homeCollectionsSeeAll: "Voir tout",
    
    // Search bar common elements
//     date: "Date",
    time: "Heure",
    city: "Ville",
//     enterCity: "Entrez une ville",
//     
//     // Transport tab
    sourceCity: "Ville de départ",
    destinationCity: "Ville d'arrivée",
    enterSourceCity: "Entrez la ville de départ",
    enterDestinationCity: "Entrez la ville d'arrivée",
    
    // Car rental tab
//     carType: "Type de voiture",
    enterCarType: "Entrez le type de voiture",
    
    // Additional translations for the search bar
    trustPartnerDesc: "Votre partenaire de confiance pour découvrir l'authenticité du Maroc",
    // Contact Page
    contact: "Téléphone",
    contactUs: "Contactez-nous",
    contactHeroTitle: "Nous sommes à votre <span class='text-orange-600'>écoute</span>",
    contactHeroDesc: "Une question sur nos services ou une demande personnalisée ? Notre équipe PalaisTouristique est à votre disposition pour vous accompagner dans votre projet.",
    contactAvgResponse15m: "Reponse moyenne en moins de 15 minutes",
    contactHotlineTitle: "Hotline directe",
    contactHotlineDesc: "Appelez maintenant pour une assistance immediate.",
    contactAppointmentTitle: "Rendez-vous",
    contactScheduleCall: "Planifier un appel",
    contactAppointmentDesc: "Choisissez un créneau avec notre equipe voyage.",
    contactPriorityEmailTitle: "Email prioritaire",
    contactPriorityEmailDesc: "Envoyez votre brief et recevez une proposition detaillee.",
    sendMessage: "Envoyez-nous un message",
//     fullName: "Nom complet",
//     fullNamePlaceholder: "Votre nom",
//     emailPlaceholder: "Votre email",
    telephone: "Téléphone",
    telephonePlaceholder: "Votre numéro",
    subject: "Sujet",
    selectSubject: "Sélectionnez un sujet",
    reservation: "Réservation",
    customServices: "Services personnalisés",
    partnership: "Partenariat",
    other: "Autre",
    message: "Message",
    messagePlaceholder: "Votre message",
//     sending: "Envoi en cours...",
    sendMessageButton: "Envoyer le message",
    contactFormSent: "Votre message a été envoyé !",
    ourContactDetails: "Nos coordonnées",
//     address: "Adresse",
    openingHours: "Heures d'ouverture",
    openingHoursDetails: "Lundi - Vendredi: 8h00 - 18h00",
    loadingMap: "Chargement de la carte...",
    bookAppointment: "Prendre rendez-vous",
    appointmentDesc: "Nos conseillers sont disponibles pour des rendez-vous personnalisés. Réservez directement votre créneau en ligne ou contactez-nous par téléphone.",
    bookOnline: "Réserver en ligne",
    callNow: "Appeler maintenant",
    bookYourAppointment: "Réservez votre rendez-vous",
    close: "Fermer",
    calendlyWidget: "Widget Calendly ici (intégration à faire)",
    faqTitle: "Questions Fréquemment Posées",
    faqSectionTitle: "Questions Fréquemment Posées",
    faqQ1: "Comment réserver un séjour ?",
    faqA1: "Vous pouvez réserver directement sur notre site ou nous contacter via le formulaire.",
    faqQ2: "Quels moyens de paiement acceptez-vous ?",
    faqA2: "Nous acceptons les cartes de crédit, virements bancaires et espèces à l'agence.",
    faqQ3: "Proposez-vous des offres de groupe ?",
    faqA3: "Oui, nous avons des offres spéciales pour les groupes et agences.",
    faqQ4: "Puis-je annuler ou modifier ma réservation ?",
    faqA4: "Oui, selon les conditions de l'offre. Contactez-nous pour plus de détails.",
    faq1Question: "Comment réserver un séjour ?",
    faq1Answer: "Vous pouvez réserver directement sur notre site ou nous contacter via le formulaire.",
    faq2Question: "Quels moyens de paiement acceptez-vous ?",
    faq2Answer: "Nous acceptons les cartes de crédit, virements bancaires et espèces à l'agence.",
    faq3Question: "Proposez-vous des offres de groupe ?",
    faq3Answer: "Oui, nous avons des offres spéciales pour les groupes et agences.",
    faq4Question: "Puis-je annuler ou modifier ma réservation ?",
    faq4Answer: "Oui, selon les conditions de l'offre. Contactez-nous pour plus de détails.",
    startChat: "Démarrer le Chat",
    businessHours: "Lundi - Vendredi: 9h00 - 18h00",
    responseTime: "Réponse sous 24 heures",
//     searchHelp: "Rechercher de l'aide...",
    readyToPlan: "Prêt à planifier votre séjour ?",
    readyToPlanDesc: "Notre équipe PalaisTouristique est prête à vous accompagner pour une expérience inoubliable au Maroc.",
    discoverOurStays: "Découvrir nos séjours",
    // Login Page
    loginTitle: "Connexion à votre compte",
    loginWelcomeTitle: "Bon retour !",
    loginWelcomeSubtitle: "Connectez-vous à votre compte pour continuer votre aventure",
    loginButton: "Se connecter",
    loggingIn: "Connexion en cours...",
    loginError: "Échec de connexion. Vérifiez vos identifiants.",
    googleLoginError: "Échec de la connexion avec Google. Veuillez réessayer.",
    googleLoginFailed: "La connexion avec Google a échoué.",
    noAccountPrompt: "Pas encore de compte ?",
    createAccount: "Créer un compte",
    or: "ou",
    emailLabel: "Adresse email",
    phoneLabel: "Numéro de téléphone",
    noAccount: "Pas de compte ? S'inscrire",
    // Register Page
    registerTitle: "Créer un compte",
    registerWelcomeTitle: "Rejoignez-nous !",
    registerWelcomeSubtitle: "Créez votre compte et découvrez l'authenticité du Maroc",
    username: "Nom d'utilisateur",
    usernamePlaceholder: "Votre nom d'utilisateur",
    password: "Mot de passe",
    passwordPlaceholder: "Votre mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    confirmPasswordPlaceholder: "Confirmez votre mot de passe",
    registerButton: "S'inscrire",
    registering: "Inscription en cours...",
    registerSuccess: "Inscription réussie. Vous pouvez maintenant vous connecter.",
    registerErrorPrefix: "Échec de l'inscription. ",
    registerError: "Échec de l'inscription. Veuillez réessayer.",
    passwordMismatch: "Les mots de passe ne correspondent pas",
    passwordsMatch: "Les mots de passe correspondent",
    passwordComplexity: "Le mot de passe doit contenir au moins 6 caractères, dont une majuscule, une minuscule et un chiffre",
    phoneRequired: "Le numéro de téléphone est requis",
    pleaseRetry: "Veuillez réessayer.",
    googleLoginSuccess: "Connexion via Google réussie.",
    createMyAccount: "Créer mon compte",
    alreadyRegisteredPrompt: "Déjà inscrit ?",
    pwdRuleLength: "Au moins 6 caractères",
    pwdRuleUpper: "Une lettre majuscule",
    pwdRuleLower: "Une lettre minuscule",
    pwdRuleNumber: "Un chiffre",
    alreadyRegistered: "Déjà inscrit ? Se connecter",
    // Process Section (Services)
    processTitle: "Notre processus",
    processDesc: "Un processus fluide pour planifier votre aventure marocaine parfaite",
    search: "Rechercher",
    searchDesc: "Recherchez votre service préféré, des riads aux visites guidées, avec nos filtres intuitifs",
    select: "Sélectionner",
    selectDesc: "Choisissez parmi notre sélection d'expériences marocaines authentiques adaptées à vos besoins",
    book: "Réserver",
    bookDesc: "Sécurisez votre réservation avec notre processus fluide et des options de paiement flexibles",
    enjoy: "Profiter",
    enjoyDesc: "Vivez la magie du Maroc en toute confiance, soutenu par notre équipe locale 24/7",
    //location
//     carRentalTitle: "Location de voiture au Maroc",
    carRentalDesc: "Explorez le Maroc à votre rythme avec nos services de location de voiture fiables et abordables",
//     pickupLocation: "Lieu de prise en charge",
    pickupDate: "Date de prise en charge",
    returnDate: "Date de retour",
//     carType: "Type de voiture",
//     allTypes: "Tous types",
    economy: "Économique",
    suv: "SUV",
    luxury: "Luxe",
    van: "Van",
    searchCars: "Rechercher des voitures",
    noCarsFound: "Aucune voiture trouvée correspondant à vos critères",
    day: "jour",
    rentNow: "Louer maintenant",
    reserveCar: "Réserver",
    pricePerDay: "Prix par jour",
//     total: "Total",
//     comments: "Commentaires / Demandes spéciales",
//     confirmReservation: "Confirmer la réservation",
//     cancel: "Annuler",
    errorFetchingCars: "Erreur lors du chargement des locations de voiture",
//     reservationSuccess: "Réservation effectuée avec succès !",
//     reservationError: "Erreur lors de la réservation",
//     tryAgain: "Réessayer",
//     bookingProcessTitle: "Processus de réservation",
    carRentalProcess: "Louez votre voiture en toute simplicité",
    carRentalProcessDesc: "Suivez ces étapes simples pour louer une voiture pour votre aventure marocaine",
    //Cicuit
    reviews: "avis",
//     perPerson: "par personne",
    aboutCircuit: "À propos de ce circuit",
//     highlights: "Points forts",
    included: "Ce qui est inclus",
    transport: "Transport",
    accommodation: "Hébergement",
    guidedTour: "Visite guidée",
    activities: "Activités",
//     startDate: "Date de départ",
//     numberOfPeople: "Nombre de personnes",
    travelerInfo: "Informations des voyageurs",
    traveler: "Voyageur",
//     lastName: "Nom",
//     firstName: "Prénom",
    dateOfBirth: "Date de naissance",
    nationality: "Nationalité",
    passportNumber: "Numéro de passeport",
    passportExpiry: "Date d'expiration du passeport",
//     comments: "Commentaires / Demandes spéciales",
//     pricePerPerson: "Prix par personne",
//     total: "Total",
//     confirmReservation: "Confirmer la réservation",
//     cancel: "Annuler",
    availableYearRound: "Disponible toute l'année",
    idealFor: "Idéal pour",
    allTravelers: "Tous types de voyageurs",
//     freeCancellation: "Annulation gratuite jusqu'à 7 jours avant le départ",
    backToCircuits: "Retour aux circuits",
    errorFetchingCircuit: "Erreur lors du chargement des détails du circuit",
    circuitNotFound: "Circuit introuvable",
//     reservationSuccess: "Réservation effectuée avec succès ! Redirection vers vos réservations...",
//     reservationError: "Erreur lors de la réservation",
//     bookingProcessTitle: "Processus de réservation",
    bookingProcess: "Planifiez votre circuit en toute simplicité",
    bookingProcessDesc: "Suivez ces étapes simples pour réserver votre aventure marocaine parfaite",
    selectDates: "Sélectionner les dates",
    selectDatesDesc: "Choisissez votre date de départ pour le circuit",
    //Visite Guidée 
//     guidedToursTitle: "Visites guidées au Maroc",
    guidedToursDesc: "Découvrez l’histoire et la culture riches du Maroc avec nos visites guidées par des experts",
//     location: "Lieu",
//     date: "Date",
//     tourType: "Type de visite",
//     allTypes: "Tous types",
    cultural: "Culturel",
    historical: "Historique",
    nature: "Nature",
    adventure: "Aventure",
    enterCity: "Entrez une ville",
    searchTours: "Rechercher des visites",
    noToursFound: "Aucune visite trouvée correspondant à vos critères",
    perPerson: "personne",
    bookNow: "Réserver maintenant",
    reserveTour: "Réserver",
    pricePerPerson: "Prix par personne",
    numberOfPeople: "Nombre de personnes",
    comments: "Commentaires / Demandes spéciales",
    confirmReservation: "Confirmer la réservation",
//     cancel: "Annuler",
    errorFetchingTours: "Erreur lors du chargement des visites guidées",
    reservationSuccess: "Réservation effectuée avec succès !",
    reservationError: "Erreur lors de la réservation",
    tryAgain: "Réessayer",
//     highlights: "Points forts",
    bookingProcessTitle: "Processus de réservation",
    tourBookingProcess: "Réservez votre visite guidée en toute simplicité",
    tourBookingProcessDesc: "Suivez ces étapes simples pour explorer le Maroc avec des guides experts",
    //Pro
    proDashboard: "Tableau de bord professionnel",
    proDashboardDesc: "Gérez vos offres de voyage, réservations et communications avec les clients en toute simplicité",
    listings: "Annonces",
    bookings: "Réservations",
    messages: "Messages",
    analytics: "Analytique",
    createListing: "Créer une annonce",
    createListingDesc: "Ajoutez vos hôtels, circuits, voitures ou visites pour attirer des clients",
    manageBookings: "Gérer les réservations",
    manageBookingsDesc: "Examinez et mettez à jour les statuts des réservations pour tenir les clients informés",
    engageClients: "Engager les clients",
    engageClientsDesc: "Répondez aux demandes des clients et construisez des relations durables",
    hotel: "Hôtel",
    circuit: "Circuit",
    car: "Location de voiture",
    tour: "Visite guidée",
    type: "Type",
    title: "Titre",
    description: "Description",
    price: "Prix (€)",
    location: "Lieu",
    create: "Créer",
    cancel: "Annuler",
    published: "Publié",
    draft: "Brouillon",
    publish: "Publier",
    unpublish: "Dépublier",
    noListings: "Aucune annonce trouvée. Créez-en une pour commencer",
    client: "Client",
    date: "Date",
    total: "Total",
    pending: "En attente",
    confirmed: "Confirmé",
    canceled: "Annulé",
    noBookings: "Aucune réservation trouvée",
    from: "À partir de",
    noMessages: "Aucun message trouvé",
    messageMarkedRead: "Message marqué comme lu",
    totalBookings: "Total des réservations",
    revenue: "Revenus",
    pendingBookings: "Réservations en attente",
    errorFetchingProfile: "Erreur lors de la vérification du statut de l'utilisateur",
    errorFetchingData: "Erreur lors du chargement des données professionnelles",
    errorCreatingListing: "Erreur lors de la création de l'annonce",
    errorUpdatingListing: "Erreur lors de la mise à jour de l'annonce",
    errorDeletingListing: "Erreur lors de la suppression de l'annonce",
    errorUpdatingBooking: "Erreur lors de la mise à jour de la réservation",
    errorUpdatingMessage: "Erreur lors de la mise à jour du message",
    listingCreated: "Annonce créée avec succès",
    listingUpdated: "Statut de l'annonce mis à jour",
    listingDeleted: "Annonce supprimée avec succès",
    bookingUpdated: "Statut de la réservation mis à jour",
    notProUser: "Accès restreint aux utilisateurs professionnels",
    backToHome: "Retour à l'accueil",
    confirmDelete: "Êtes-vous sûr de vouloir supprimer cette annonce ?",
    proProcessTitle: "Comment ça marche",
    proProcess: "Gérez votre entreprise en toute simplicité",
    proProcessDesc: "Suivez ces étapes simples pour développer votre entreprise de voyage au Maroc",
    //Edit Listing
    editListing: "Modifier l'annonce",
    editListingDesc: "Mettez à jour les détails de votre annonce pour attirer plus de clients",
    amenities: "Équipements",
//     itinerary: "Itinéraire",
    features: "Caractéristiques",
    highlights: "Points forts",
    addAmenity: "Ajouter un équipement (par exemple, Wi-Fi)",
    addItinerary: "Ajouter un élément d'itinéraire (par exemple, Jour 1 : Marrakech)",
    addFeature: "Ajouter une caractéristique (par exemple, Climatisation)",
    addHighlight: "Ajouter un point fort (par exemple, Visite de la Médina)",
    saveChanges: "Enregistrer les modifications",
    fillAllFields: "Veuillez remplir tous les champs requis",
    positivePrice: "Le prix doit être un nombre positif",
    errorFetchingListing: "Erreur lors du chargement des données de l'annonce",
    backToDashboard: "Retour au tableau de bord",
    
    // About Page
    aboutPageTitle: "À propos du Palais Touristique",
    aboutPageSubtitle: "Votre partenaire de confiance pour des expériences marocaines authentiques",
    ourStory: "Notre Histoire",
    ourStoryDesc: "Fondé avec une passion pour présenter la riche culture et le patrimoine du Maroc,Palais Touristique crée des expériences de voyage inoubliables pour les visiteurs du monde entier.",
    ourMission: "Notre Mission",
    ourMissionDesc: "Fournir des expériences de voyage authentiques, personnalisées et mémorables qui connectent nos clients avec la véritable essence du Maroc.",
    ourValues: "Nos Valeurs",
    ourValuesDesc: "Nous croyons en l'authenticité, l'excellence et la création de souvenirs durables grâce à de véritables échanges culturels.",
    
    // Press Page
    pressPageTitle: "Presse et Médias",
    pressPageSubtitle: "Dernières nouvelles et couverture médiatique sur Palais Touristique",
    pressReleases: "Communiqués de Presse",
    mediaCoverage: "Couverture Médiatique",
    mediaInquiries: "Demandes Médias",
    mediaInquiriesDesc: "Pour les demandes de presse, veuillez contacter notre équipe des relations médias.",
    
    // Blog Page
    blogPageTitle: "Blog de Voyage",
    blogPageSubtitle: "Découvrez le Maroc à travers nos histoires et guides de voyage",
    readMore: "Lire Plus",
    
    // Help Page
    helpPageTitle: "Centre d'Aide",
    helpPageSubtitle: "Trouvez des réponses à vos questions et obtenez de l'aide",
    searchHelp: "Rechercher de l'aide...",
    frequentlyAsked: "Questions Fréquemment Posées",
    liveChat: "Chat en Direct",
    liveChatDesc: "Chattez avec notre équipe de support en temps réel",
    phoneSupport: "Support Téléphonique",
    phoneSupportDesc: "Appelez-nous pour une assistance immédiate",
    emailSupport: "Support Email",
    emailSupportDesc: "Envoyez-nous un email et nous répondrons dans les 24 heures",
    
    // Cancellation Page
    cancellationPageTitle: "Politique d'Annulation",
    cancellationPageSubtitle: "Comprendre nos conditions et procédures d'annulation",
    cancellationPolicy: "Politique d'Annulation",
    cancellationPolicies: "Politiques d'Annulation",
    hotelReservations: "Réservations d'Hôtel",
    hotelCancellation: "Réservations d'Hôtel",
    hotelCancellationDesc: "Annulation gratuite jusqu'à 24 heures avant l'arrivée",
    hotelFreeCancel: "Annulation gratuite jusqu'à 24 heures avant l'arrivée",
    hotelPartialRefund: "Remboursement de 50% entre 24-48 heures avant l'arrivée",
    hotelNoRefund: "Aucun remboursement moins de 24 heures avant l'arrivée",
    circuitTours: "Tours & Circuits",
    tourCancellation: "Tours & Circuits",
    tourCancellationDesc: "Annulation gratuite jusqu'à 7 jours avant le départ",
    toursFreeCancel: "Annulation gratuite jusqu'à 7 jours avant le départ",
    toursPartialRefund: "Remboursement de 50% entre 3-7 jours avant le départ",
    toursNoRefund: "Aucun remboursement moins de 3 jours avant le départ",
    carRentals: "Location de Voiture",
    carCancellation: "Location de Voiture",
    carCancellationDesc: "Annulation gratuite jusqu'à 48 heures avant la prise en charge",
    carFreeCancel: "Annulation gratuite jusqu'à 48 heures avant la prise en charge",
    carPartialRefund: "Remboursement de 50% entre 24-48 heures avant la prise en charge",
    carNoRefund: "Aucun remboursement moins de 24 heures avant la prise en charge",
    guidedFreeCancel: "Annulation gratuite jusqu'à 24 heures avant la visite",
    guidedPartialRefund: "Remboursement de 50% entre 12-24 heures avant la visite",
    guidedNoRefund: "Aucun remboursement moins de 12 heures avant la visite",
    importantNotice: "Avis Important",
    importantNoticeDesc: "Veuillez lire attentivement nos politiques d'annulation avant de réserver. Le traitement des remboursements peut prendre 5 à 10 jours ouvrables.",
    freeCancellation: "Annulation Gratuite",
    partialRefund: "Remboursement Partiel",
    // Safety Page
    safetyPageTitle: "Sécurité et Sûreté",
    safetyPageSubtitle: "Votre sécurité est notre priorité absolue",
    safetyMeasures: "Mesures de Sécurité",
    safetyMeasuresDesc: "Nous mettons en œuvre des protocoles de sécurité complets pour tous nos services",
    travelTips: "Conseils de Sécurité Voyage",
    travelTipsDesc: "Directives de sécurité essentielles pour voyager au Maroc",
    verifiedPartners: "Partenaires Vérifiés",
    verifiedPartnersDesc: "Tous nos hôtels, prestataires de transport et guides touristiques sont rigoureusement vérifiés et certifiés.",
    professionalGuides: "Guides Professionnels",
    professionalGuidesDesc: "Nos guides touristiques agréés sont formés aux protocoles de sécurité et aux procédures d'urgence.",
    safeLocations: "Lieux Sûrs",
    safeLocationsDesc: "Nous n'opérons que dans des zones sûres et touristiques avec une infrastructure et une sécurité appropriées.",
    support247: "Support 24/7",
    support247Desc: "Notre équipe d'assistance d'urgence est disponible 24h/24 pour toute aide dont vous avez besoin.",
    emergencyContacts: "Contacts d'Urgence",
    emergencyContactsDesc: "Enregistrez ces numéros dans votre téléphone avant de voyager. En cas d'urgence, appelez immédiatement le service approprié.",
    healthInfo: "Santé et Médical",
    beforeYouTravel: "Avant de Voyager",
    duringYourStay: "Pendant votre Séjour",
    
    // CGV Page
    cgvTitle: "Conditions Générales de Vente",
    cgvPreamble: "1. Préambule",
    cgvPreambleContent: "Les présentes conditions générales de vente régissent toutes les transactions établies via le site web de Palais Touristique. Toute transaction traitée via ce site web suppose l'acceptation inconditionnelle et irrévocable de ces conditions par le client.",
    cgvPurpose: "2. Objet",
    cgvPurposeContent: "Ces conditions visent à définir les droits et obligations des parties dans le cadre de la vente en ligne effectuée via le site web de Palais Touristique.",
    cgvSales: "3. Ventes",
    cgvSalesContent: "Le client se connecte au site web de Palais Touristique et sélectionne les articles qu'il souhaite acheter. Il remplit ensuite ses informations d'identité, accepte les conditions et clique sur le bouton « Payer ». Le client est ainsi redirigé vers la plateforme de paiement sécurisé en ligne du Centre Monétique Interbancaire où il complète ses informations de paiement et valide le paiement.",
    cgvPaymentMethods: "4. Méthodes de Paiement",
    cgvPaymentMethodsContent: "Pour payer sur Internet par carte bancaire, le client est invité à saisir ses coordonnées de carte de paiement sur la page de paiement sécurisée. Lorsque la transaction est acceptée par la banque, le règlement pour débiter son compte est effectué dans le jour ouvrable suivant la date de confirmation de la transaction.\n\nLes cartes bancaires acceptées pour le règlement en ligne sont les cartes Visa et Mastercard. Toutes les transactions sont réalisées exclusivement en dirham marocain (MAD).\n\nLe paiement en ligne par carte bancaire est sécurisé par le Centre Monétique Interbancaire (CMI), qui fournit un service de paiement entièrement sécurisé. Chaque transaction est protégée par le protocole 3-D Secure, qui authentifie le porteur de la carte auprès de sa banque émettrice avant la validation du paiement.\n\nLes coordonnées de la carte bancaire (numéro, date d'expiration, cryptogramme visuel) sont saisies directement sur la page de paiement sécurisée du CMI : elles ne sont à aucun moment vues, traitées ou conservées par Palais Touristique. En cas d'annulation, de non-exécution ou de remboursement, le montant correspondant est recrédité sur la carte bancaire ayant servi au paiement initial.\n\nLe client garantit au site web de Palais Touristique qu'il est pleinement autorisé à utiliser la carte bancaire choisie et qu'il dispose des fonds nécessaires lors de la validation du paiement.",
    cgvPrivacy: "5. Confidentialité des Données",
    cgvPrivacyContent: "Les informations demandées au client lors du paiement en ligne sont nécessaires au traitement de la transaction en ligne. Elles sont traitées de manière confidentielle. Le client a le droit de consulter ou de rectifier ses données personnelles.",
    cgvProof: "6. Preuve de paiement",
    cgvProofContent: "Les données stockées sur la plateforme en ligne du Centre Monétique Interbancaire pour le compte du site web de Palais Touristique sont considérées comme preuve de paiement pour la transaction en ligne effectuée par le client.",
    
    // Secure Payment Page
    securePaymentTitle: "Paiement Sécurisé",
    securePaymentDesc: "Vos transactions sont sécurisées via la plateforme CMI et protégées par 3D Secure.",
    threeDSecure: "Le 3D Secure (Verified by Visa / Mastercard SecureCode) ajoute une couche de sécurité lors du paiement.",
    
    // Footer Extras
    securedByCMI: "Sécurisé par CMI",
    builtWithCare: "Fait par KYBOHO",
    emailUs: "Email",
    callUs: "Téléphone",
    footerLocation: "Adresse",
    footerRights: "Tous droits réservés",
    noRefund: "Aucun Remboursement",
    howToCancel: "Comment Annuler",
    howToCancelDesc: "Vous pouvez annuler votre réservation via votre compte ou en contactant notre équipe de support.",
    step1Title: "Connectez-vous à Votre Compte",
    step1Desc: "Accédez à votre tableau de bord de réservation via votre compte",
    step2Title: "Trouvez Votre Réservation",
    step2Desc: "Localisez la réservation que vous souhaitez annuler",
    step3Title: "Demander l'Annulation",
    step3Desc: "Cliquez sur annuler et suivez les étapes de confirmation",
    needHelpTitle: "Besoin d'Aide pour l'Annulation?",
    needHelpDesc: "Notre équipe de support est là pour vous aider avec toute question ou préoccupation concernant l'annulation.",
    contactSupport: "Contacter le Support",
    
    // =============================
// Page Séjour
// =============================
sejourTitle: "Séjour & Hébergement",
sejourSubtitleNew:
  "Déposez votre demande (hôtel/riad) via le formulaire. Notre équipe vous proposera la meilleure offre et vous enverra un lien de paiement sécurisé.",

// Dictée vocale (STT)
sejourVoiceTitle: "Dictée vocale (Séjour) 🎙️",
sejourAutofillBtn: "✨ NOUZHA AI",
sejourSpeakFirst: "Parle d'abord, puis clique sur Autofill.",
sejourTranscriptionPlaceholder: "La transcription s’affiche ici...",
sejourVoiceHint: "Astuce : dis “arrivée le … départ le … budget … services wifi parking …”.",

// Sections
sejourInfoTitle: "Informations du séjour",
sejourServicesTitle: "Services souhaités dans l’hébergement",
sejourPersonalInfoTitle: "Informations personnelles",
sejourCgvTitle: "CGV / Paiement",
sejourSubmitHint:
  "Après soumission, un agent traitera votre demande, sélectionnera l’offre la plus adaptée, fixera le tarif final et vous enverra un email avec un lien de paiement sécurisé.",

// Labels
sejourCityLabel: "Ville souhaitée *",
sejourCityPlaceholder: "Ex: Fès, Rabat, Marrakech...",
sejourGuestsLabel: "Nombre d’invités *",
sejourGuestOne: "invité",
sejourGuestsMany: "invités",

sejourArrivalLabel: "Date d’arrivée *",
sejourDepartureLabel: "Date de départ *",

sejourStarsLabel: "Catégorie (étoiles)",
sejourStarsAll: "Tous",
sejourStarsHint:
  "L’agent proposera l’hébergement le plus adapté selon la disponibilité.",

sejourBudgetLabel: "Budget par nuit (MAD) *",
sejourMin: "Min",
sejourMax: "Max",
sejourBudgetHint: "Indique un intervalle réaliste pour accélérer le traitement.",

// Discount
sejourDiscountLabel: "Je souhaite recevoir une offre avec réduction si disponible",

// Personal fields
sejourFullNameLabel: "Nom complet *",
sejourFullNamePlaceholder: "Ex: Nom complet",
sejourEmailLabel: "Email *",
sejourEmailAccountLabel: "Email (compte)",
sejourEmailAccountHint: "Cette adresse est liée à votre compte et ne peut pas être modifiée ici.",
sejourPhoneLabel: "Téléphone *",
sejourPhonePlaceholder: "Ex: +212 6xx xx xx xx",
sejourAddressLabel: "Adresse *",
sejourAddressPlaceholder: "Ex: Quartier, rue, ville...",

// CGV / payment
sejourAcceptText1: "J’ai lu et j’accepte les",
sejourAcceptCgvLink: "Conditions Générales de Vente",
sejourAcceptText2: "ainsi que les conditions de paiement via CMI.",
sejourSecurePayment: "Paiement sécurisé :",
sejourPaymentInfoLink: "Voir les informations CMI / Visa / MasterCard / 3DS",
sejourMustAccept: "Pour envoyer la demande, vous devez d’abord accepter les conditions (CMI/CGV).",

// Buttons
sejourSending: "Envoi en cours...",
sejourSubmitBtn: "Soumettre ma demande",
sejourAnotherRequest: "Faire une autre demande",

// Success
sejourSuccessTitle: "Demande envoyée avec succès !",
sejourSuccessDesc:
  "Nous avons bien reçu votre demande de séjour. Notre agent va l’étudier et vous contactera par email avec une proposition et un lien de paiement.",

// Datepicker
// dpPlaceholder: "jj/mm/aaaa",
// dpClear: "Effacer",
// dpToday: "Aujourd’hui",
// dpMon: "lu",
// dpTue: "ma",
// dpWed: "me",
// dpThu: "je",
// dpFri: "ve",
// dpSat: "sa",
// dpSun: "di",
// 
// // Validation / errors
errCityRequired: "Veuillez saisir la ville.",
errArrivalRequired: "Veuillez choisir la date d’arrivée.",
errDepartureRequired: "Veuillez choisir la date de départ.",
errDepartureAfterArrival: "La date de départ doit être après la date d’arrivée.",
errFullNameRequired: "Veuillez saisir votre nom complet.",
errEmailRequired: "Veuillez saisir votre email.",
errPhoneRequired: "Veuillez saisir votre téléphone.",
errAddressRequired: "Veuillez saisir votre adresse.",
errAcceptCgvRequired: "Veuillez accepter les conditions de paiement (CMI/CGV).",
errPriceRange: "Veuillez vérifier l’intervalle de prix.",

// Gemini
// geminiError: "Erreur Gemini",
// geminiNetworkError: "Erreur réseau / serveur Gemini",
// geminiAutofillSuccess: "Formulaire séjour rempli à partir de ta voix ✅",
// 
// // =============================
// // Page Circuit
// // =============================
circuitTitle: "Demande de Circuit Touristique",
circuitSubtitle: "Remplissez le formulaire et nous vous proposerons un circuit sur mesure.",

// Sections
tripInfo: "Informations du voyage",
itinerary: "Stations (Itinéraire)",
// personalInfo: "Informations personnelles",
// paymentConditions: "Conditions de paiement (CMI)",
// 
// // Voice / STT
circuitVoiceTitle: "Dictée vocale (Circuit) 🎙️",
circuitAutofillBtn: "✨ NOUZHA AI",
circuitSpeakFirst: "Parle d'abord, puis clique sur Autofill.",
circuitTranscriptPlaceholder: "La transcription s’affiche ici...",
circuitVoiceHint:
  "Exemple : “Destination Fès, date 2026-01-12, durée 4 jours, type famille, budget 2000 à 4000, stations Rabat puis Tanger…”",

// Champs (voyage)
destination: "Destination",
// chooseCity: "Choisissez une ville...",
travelDate: "Date de voyage",
duration: "Durée",
allDurations: "Choisir...",
travelType: "Type de voyage",
allTypes: "Choisir...",
budget: "Budget (optionnel)",
minPrice: "Prix min",
maxPrice: "Prix max",

// Valeurs
day1: "1 jour",
days2: "2 jours",
days3: "3 jours",
days4: "4 jours",
days5: "5 jours",
weekend: "Weekend",
week: "1 semaine",
days10: "10 jours",
weeks2: "2 semaines",

typeSolo: "Solo",
typeCouple: "Couple",
typeFamily: "Famille",
typeGroup: "Groupe",
typeFriends: "Entre amis",

// Stations
addStation: "Ajouter une station",
add: "Ajouter",
stationsExample: "Exemple : Fès → Rabat → Larache → Asilah → Tanger",
stationPlaceholder: "Ex: Fès, Rabat, Larache...",

// Perso
// fullName: "Nom complet",
// fullNamePlaceholder: "Ex: Nom complet",
// emailLabel: "Email",
emailAccountLabel: "Email (compte)",
emailAccountHint: "Cette adresse est liée à votre compte et ne peut pas être modifiée ici.",

// phonePlaceholder: "Ex: +212 6xx xx xx xx",
addressLabel: "Adresse",
// addressPlaceholder: "Ex: Quartier, rue, ville...",
// 
// // CMI
// cmiAcceptText:
//   "J’accepte les conditions de paiement et j’autorise la génération d’un lien CMI pour finaliser ma réservation.",
cmiMustAcceptHint: "Pour activer le bouton, veuillez cocher l’acceptation des conditions de paiement.",

// Boutons / états
// sending: "Envoi en cours...",
// sendRequest: "Envoyer la demande",
// 
// // Messages
circuitRequiredError: "Veuillez remplir les champs obligatoires et accepter les conditions de paiement.",
circuitSuccessMsg:
  "Votre demande de circuit a été envoyée avec succès. Nous vous contacterons bientôt.",
circuitSendError: "Erreur lors de l’envoi de la demande. Veuillez réessayer.",

// Datepicker (réutilisé)
// dpPlaceholder: "jj/mm/aaaa",
// dpClear: "Effacer",
// dpToday: "Aujourd’hui",
// dpMon: "lu",
// dpTue: "ma",
// dpWed: "me",
// dpThu: "je",
// dpFri: "ve",
// dpSat: "sa",
// dpSun: "di",
// 
// // Gemini
// geminiError: "Erreur Gemini",
// geminiNetworkError: "Erreur réseau / serveur Gemini",
// geminiAutofillSuccess: "Formulaire circuit rempli à partir de ta voix ✅",
// 
// // =============================
// // Page Transport
// // =============================
transportTitle: "Transport Touristique",
transportSubtitle: "Transferts, navettes et mise à disposition avec chauffeur",

// Tabs
simpleTrip: "Trajet Simple",
airportShuttle: "Navette Aéroport",
privateHire: "Mise à Disposition",

// Form headers
requestTitle: "Demande - Transport",
requestSubtitle: "Remplissez le formulaire, nous vous recontacterons rapidement.",

// Voice / STT
transportVoiceTitle: "Dictée vocale (Transport) 🎙️",
transportAutofillBtn: "✨ NOUZHA AI",
transportSpeakFirst: "Parle d'abord, puis clique sur Autofill.",
transportTranscriptPlaceholder: "La transcription s’affiche ici...",
transportVoiceHint:
  "Dis: “Trajet de Fès à Rabat demain à 14h, 3 personnes …” / “Navette aéroport …” / “Mise à disposition …”",

// Common fields
// chooseCity: "Choisir une ville",
departureCity: "Ville de départ",
arrivalCity: "Ville d'arrivée",
departureDate: "Date",
departureTime: "Heure",
guests: "Invités",
passengers: "Passagers",

// Shuttle
airport: "Aéroport",
allAirports: "Choisir un aéroport",

// Disposition
// pickupLocation: "Lieu de prise en charge",
pickupLocationPlaceholder: "Adresse, hôtel...",
// startDate: "Date de début",
startTime: "Heure de début",
// endDate: "Date de fin",
serviceType: "Type de prestation",
byHour: "À l'heure",
halfDay: "Demi-journée",
fullDay: "Journée complète",
severalDays: "Plusieurs jours",

// Personal info
// personalInfo: "Informations personnelles",
personalInfoSubtitle: "Ces informations nous permettent de vous contacter.",
// fullName: "Nom complet",
fullNamePlaceholder: "Ex: Nom complet",
// email: "Email",
// phone: "Téléphone",
// address: "Adresse",
emailPlaceholder: "vous@example.com",
phonePlaceholder: "+212 6xx xx xx xx",
addressPlaceholder: "Ville, quartier, hôtel...",

// Payment / conditions
paymentConditions: "Conditions & Paiement",
paymentConditionsSubtitle: "Vous devez accepter les conditions pour envoyer votre demande.",
mustAccept: "⚠️ Veuillez cocher la case pour activer l’envoi.",
cmiAcceptText: "J’accepte les conditions de paiement CMI et la charte de service.",

// Buttons / states
// sending: "Envoi...",
sendRequest: "Envoyer la demande",

// Validation messages
// vChooseDate: "Veuillez choisir la date.",
vChooseTime: "Veuillez choisir l'heure.",
vInvalidPeople: "Nombre de personnes invalide.",
// vFullName: "Veuillez saisir votre nom complet.",
// vEmail: "Veuillez saisir votre email.",
// vPhone: "Veuillez saisir votre téléphone.",
// vAddress: "Veuillez saisir votre adresse.",
vAccept: "Veuillez accepter les conditions (CMI/Charte).",
vDepartCity: "Veuillez choisir la ville de départ.",
vArriveCity: "Veuillez choisir la ville d'arrivée.",
vDifferentCities: "Départ et arrivée doivent être différentes.",
vAirport: "Veuillez choisir l'aéroport.",
vPickup: "Veuillez saisir le lieu de prise en charge.",
// vEndDate: "Veuillez choisir la date de fin.",
// vEndAfterStart: "La date de fin doit être après la date de début.",
// 
// // Toast submit
transportSent: "✅ Demande envoyée ! Référence:",
transportError: "Erreur lors de l'envoi de la demande. Veuillez réessayer.",

// Datepicker shared
dpPlaceholder: "jj/mm/aaaa",
dpClear: "Effacer",
dpToday: "Aujourd’hui",
dpMon: "lu",
dpTue: "ma",
dpWed: "me",
dpThu: "je",
dpFri: "ve",
dpSat: "sa",
dpSun: "di",

// Gemini
// geminiError: "Erreur Gemini",
// geminiNetworkError: "Erreur réseau / serveur Gemini",
// geminiAutofillSuccess: "Formulaire transport rempli à partir de ta voix ✅",
// 
// // =============================
// // Page Location (Location voiture)
// // =============================
carRentalTitle: "Location de voiture",
carRentalSubtitleNew:
  "Déposez votre demande via le formulaire. Notre équipe vous proposera un véhicule adapté, fixera le prix final et vous enverra un lien de paiement sécurisé CMI.",

// Sections
rentalInfo: "Informations de location",
rentalPreferences: "Détails / préférences",
// personalInfo: "Informations personnelles",
// paymentCgvTitle: "Conditions & Paiement",
// 
// // STT
locationVoiceTitle: "Dictée vocale (Location) 🎙️",
locationAutofillBtn: "✨ NOUZHA AI",
locationSpeakFirst: "Parle d'abord, puis clique sur Autofill.",
locationTranscriptPlaceholder: "La transcription s’affiche ici...",
locationVoiceHint:
  "Astuce: dis “prise en charge à … début … retour … type SUV … automatique … diesel … budget …”",

// Fields (rental)
pickupLocation: "Lieu de prise en charge",
pickupLocationPh: "Ex: Aéroport Fès, Centre-ville...",
// peopleCount: "Nombre de personnes",
startDate: "Date de début",
endDate: "Date de retour",

carType: "Type de voiture",
// any: "Peu importe",
carEconomy: "Économique",
carSuv: "SUV",
carLuxury: "Luxe",
carVan: "Van / Minibus",

transmission: "Transmission",
auto: "Automatique",
manual: "Manuelle",

fuel: "Carburant",
diesel: "Diesel",
gasoline: "Essence",
hybrid: "Hybride",
electric: "Électrique",

budgetPerDay: "Budget par jour (MAD)",
budgetMin: "Min",
budgetMax: "Max",
// budgetHint: "Indique un intervalle réaliste pour accélérer le traitement.",
// 
// // Preferences / comments
// discountWish: "Je souhaite recevoir une offre avec réduction si disponible",
// commentsLabel: "Commentaires / besoins spécifiques",
commentsPh: "Ex: siège bébé, livraison à l’hôtel, boîte auto obligatoire...",

// Personal fields
// fullName: "Nom complet",
// fullNamePh: "Ex: Nom complet",
// email: "Email",
// emailAccount: "Email (compte)",
// emailPh: "vous@example.com",
// emailLockedHint: "Cette adresse est liée à votre compte et ne peut pas être modifiée ici.",
// phone: "Téléphone",
// phonePh: "Ex: +212 6xx xx xx xx",
// address: "Adresse",
// addressPh: "Ex: Quartier, rue, ville...",
// 
// // CGV/CMI
// cgvTextPrefix: "J’ai lu et j’accepte les",
// cgvLinkText: "Conditions Générales de Vente",
// cgvTextSuffix: "ainsi que les conditions de paiement via CMI.",
// securePaymentLabel: "Paiement sécurisé :",
// securePaymentLink: "Voir les informations CMI / Visa / MasterCard / 3DS",
// mustAcceptCgv: "Pour envoyer la demande, vous devez d’abord accepter les conditions (CMI/CGV).",
afterSubmitHint:
  "Après soumission, un agent traitera votre demande, sélectionnera le véhicule le plus adapté, fixera le tarif final et vous enverra un email avec un lien de paiement sécurisé.",
// cmiFooter: "Paiement final via lien sécurisé CMI (3DS)",
// 
// // Success screen
// successTitle: "Demande envoyée avec succès !",
successBody:
  "Nous avons bien reçu votre demande de location. Un agent va l’étudier et vous contactera par email avec une proposition et un lien de paiement sécurisé.",
// successNewRequest: "Faire une autre demande",
// 
// // Buttons / states
// sending: "Envoi en cours...",
// submitRequest: "Soumettre ma demande",
// 
// // Validation / Toasts
vPickupLocation: "Veuillez saisir le lieu de prise en charge.",
vStartDate: "Veuillez choisir la date de début.",
vEndDate: "Veuillez choisir la date de retour.",
vEndAfterStart: "La date de retour doit être après la date de début.",
// vFullName: "Veuillez saisir votre nom complet.",
// vEmail: "Veuillez saisir votre email.",
// vPhone: "Veuillez saisir votre téléphone.",
// vAddress: "Veuillez saisir votre adresse.",
// vBudgetRange: "Veuillez vérifier l’intervalle de budget (min/max).",
// vAcceptCgv: "Veuillez accepter les conditions de paiement (CMI/CGV).",
// 
locationSent: "Votre demande de location a été envoyée !",
// sendError: "Erreur lors de l’envoi. Veuillez réessayer.",
// 
// // Gemini
// geminiError: "Erreur Gemini",
// geminiNetworkError: "Erreur réseau / serveur Gemini",
// geminiAutofillSuccess: "Formulaire location rempli à partir de ta voix ✅",
// 
// 
// // =============================
// // Guided Tours (Visites guidées)
// // =============================
guidedToursTitle: "Visites guidées",
guidedToursSubtitleNew:
  "Déposez votre demande via le formulaire. Notre équipe vous proposera la meilleure visite, fixera le prix final et vous enverra un lien de paiement sécurisé CMI.",

// Sections
guidedInfo: "Informations de la visite guidée",
guidedPreferences: "Détails / préférences",
personalInfo: "Informations personnelles",
paymentCgvTitle: "Conditions & Paiement",

// STT
guidedVoiceTitle: "Dictée vocale (Visite guidée) 🎙️",
guidedAutofillBtn: "✨ NOUZHA AI",
speakFirst: "Parle d'abord, puis clique sur Autofill.",
transcriptPlaceholder: "La transcription s’affiche ici...",
guidedVoiceHint:
  "Astuce: parle naturellement. Chrome/Edge recommandé. En production, HTTPS requis.",

// Fields
cityPlace: "Ville / lieu",
chooseCity: "Choisir une ville...",
specifyPlace: "Précisez le lieu",
specifyPlacePh: "Ex: Volubilis, Vallée du Ziz...",
dateLabel: "Date",
tourType: "Type de visite",
peopleCount: "Nombre de personnes",
durationHours: "Durée souhaitée (heures)",
budgetTotal: "Budget total (MAD)",
minLabel: "Min",
maxLabel: "Max",
durationHint: "Ex: 2h–4h pour médina, 6h–8h pour excursion.",
budgetHint: "Indique un intervalle réaliste pour accélérer le traitement.",

// Tour types
any: "Peu importe",
tourCultural: "Culturelle",
tourHistorical: "Historique",
tourNature: "Nature",
tourAdventure: "Aventure",

// Preferences
discountWish: "Je souhaite recevoir une offre avec réduction si disponible",
commentsLabel: "Commentaires / besoins spécifiques",
guidedCommentsPh: "Ex: guide francophone, accessible, visite privée, points d’intérêt...",

// Personal fields
fullName: "Nom complet",
fullNamePh: "Ex: Nom complet",
email: "Email",
emailAccount: "Email (compte)",
emailPh: "vous@example.com",
emailLockedHint: "Cette adresse est liée à votre compte et ne peut pas être modifiée ici.",
phone: "Téléphone",
phonePh: "Ex: +212 6xx xx xx xx",
address: "Adresse",
addressPh: "Ex: Quartier, rue, ville...",

// CGV/CMI
cgvTextPrefix: "J’ai lu et j’accepte les",
cgvLinkText: "Conditions Générales de Vente",
cgvTextSuffix: "ainsi que les conditions de paiement via CMI.",
securePaymentLabel: "Paiement sécurisé :",
securePaymentLink: "Voir les informations CMI / Visa / MasterCard / 3DS",
mustAcceptCgv: "Pour envoyer la demande, vous devez d’abord accepter les conditions (CMI/CGV).",
afterSubmitGuidedHint:
  "Après soumission, un agent traitera votre demande, sélectionnera la meilleure offre, fixera le tarif final et vous enverra un email avec un lien de paiement sécurisé.",
cmiFooter: "Paiement final via lien sécurisé CMI (3DS)",

// Success screen
successTitle: "Demande envoyée avec succès !",
successGuidedBody:
  "Nous avons bien reçu votre demande de visite guidée. Un agent va l’étudier et vous contactera par email avec une proposition et un lien de paiement sécurisé.",
successNewRequest: "Faire une autre demande",

// Buttons / states
// sending: "Envoi en cours...",
// submitRequest: "Soumettre ma demande",
// 
// // Validation / Toasts
vChooseCity: "Veuillez choisir la ville / lieu.",
vChooseDate: "Veuillez choisir la date.",
vDurationRange: "Veuillez vérifier l’intervalle de durée (min/max).",
vBudgetRange: "Veuillez vérifier l’intervalle de budget (min/max).",
vFullName: "Veuillez saisir votre nom complet.",
// vEmail: "Veuillez saisir votre email.",
// vPhone: "Veuillez saisir votre téléphone.",
vAddress: "Veuillez saisir votre adresse.",
vAcceptCgv: "Veuillez accepter les conditions de paiement (CMI/CGV).",
vSpecifyOther: "Veuillez préciser le lieu (option Autre).",

// Gemini
geminiError: "Erreur Gemini",
geminiNetworkError: "Erreur réseau / serveur Gemini",
geminiAutofillSuccess: "Formulaire rempli à partir de ta voix ✅",

// Sent
guidedSent: "Votre demande de visite guidée a été envoyée !",
sendError: "Erreur lors de l’envoi. Veuillez réessayer.",


// =============================
// Agency Partnership
// =============================
agencyPartnershipTitle: "Partenariat Agences",
agencyPartnershipSubtitle:
  "Vous êtes une agence de voyage internationale ? Collaborez avec notre réseau d'agences marocaines pour offrir des services exceptionnels à vos clients au Maroc.",
agencyProgramBadge: "Programme Partenaire",
agencyBecomePartner: "Devenir partenaire",
agencyBenefitsBadge: "Avantages partenaires",
agencyWhyChoosePrefix: "Pourquoi",
agencyWhyChooseHighlight: "nous choisir",
agencyStatPartners: "Agences partenaires",
agencyStatCountries: "Pays représentés",
agencyStatSatisfaction: "Taux de satisfaction",
agencyStatResponse: "Temps de réponse",
agencyBenefit1Title: "Croissance garantie",
agencyBenefit1Desc: "Augmentez votre volume d'affaires avec notre réseau au Maroc.",
agencyBenefit2Title: "Fiabilité totale",
agencyBenefit2Desc: "Partenaire certifié avec des standards de qualité exigeants.",
agencyBenefit3Title: "Support dédié",
agencyBenefit3Desc: "Un account manager personnel pour chaque partenaire agence.",
agencyBenefit4Title: "Commissions attractives",
agencyBenefit4Desc: "Des marges compétitives qui récompensent votre fidélité.",
agencyHowToBecomePrefix: "Comment devenir",
agencyHowToBecomeHighlight: "partenaire",
agencyStep1Title: "Candidature",
agencyStep1Desc: "Remplissez le formulaire ci-dessous",
agencyStep2Title: "Évaluation",
agencyStep2Desc: "Notre équipe étudie votre profil",
agencyStep3Title: "Collaboration",
agencyStep3Desc: "Démarrez votre partenariat",
agencyTestimonial1Quote: "Le meilleur partenaire au Maroc. Un service impeccable et des réponses ultra-rapides.",
agencyTestimonial1Agency: "Voyages Horizon, France",
agencyTestimonial2Quote: "Grâce à Nouzha, nous avons doublé notre offre Maroc en un an. Très professionnel.",
agencyTestimonial2Agency: "Sol y Luna Travel, Espagne",
agencyTestimonial3Quote: "Collaboration fluide, commissions attractives et qualité constante. Je recommande.",
agencyTestimonial3Agency: "Wanderlust Tours, Allemagne",
agencyServiceTypeAccommodation: "Hébergement (Hôtels/Riads)",
agencyServiceTypeCircuits: "Circuits organisés",
agencyServiceTypeTransport: "Transport touristique",
agencyServiceTypeGuides: "Guides touristiques",
agencyServiceTypeCarRental: "Location de véhicules",
agencyServiceTypeGuidedTours: "Visites guidées",
agencyServiceTypeAdventure: "Activités d'aventure",
agencyServiceTypeEvents: "Événements et MICE",
agencyServiceTypeTransfers: "Transferts aéroport",
agencyServiceTypeAssistance: "Assistance 24/7",
agencyLanguageFrench: "Français",
agencyLanguageEnglish: "Anglais",
agencyLanguageSpanish: "Espagnol",
agencyLanguageItalian: "Italien",
agencyLanguageGerman: "Allemand",
agencyLanguagePortuguese: "Portugais",
agencyLanguageArabic: "Arabe",
agencyLanguageBerber: "Berbère",
agencySidebarImageAlt: "Morocco partnership",
agencySidebarJoinTitle: "Rejoignez notre réseau",
agencySidebarJoinDesc: "150+ agences nous font déjà confiance",
agencySidebarWhatYouGet: "Ce que vous obtenez",
agencySidebarBenefit1: "Dashboard partenaire dédié",
agencySidebarBenefit2: "Tarifs préférentiels garantis",
agencySidebarBenefit3: "Support multilingue 7j/7",
agencySidebarBenefit4: "Formation sur nos produits",
agencySidebarBenefit5: "Marketing co-brandé",
agencySidebarBenefit6: "Paiements rapides",
agencySidebarQuestions: "Des questions ?",
agencySidebarQuestionsDesc: "Notre équipe commerciale est à votre disposition pour tout renseignement.",

// Success screen
agencySuccessTitle: "Demande de partenariat envoyée!",
agencySuccessBody:
  "Nous avons bien reçu votre demande. Notre équipe commerciale va l'étudier et vous contactera dans les plus brefs délais.",
agencyNewRequest: "Nouvelle demande",

// Sections
agencyInfoTitle: "Informations sur votre agence",
agencyServicesProvided: "Types de services que vous proposez",
agencyTeamLanguages: "Langues parlées dans votre équipe",
agencyAgencyPresentation: "Présentation de votre agence",
agencyRequiredServicesTitle: "Services requis au Maroc",
agencyAddService: "Ajouter un service",
agencyContactTitle: "Contact principal",

// Fields (agency)
agencyName: "Nom de votre agence",
agencyCountry: "Pays d'origine",
agencyWebsite: "Site web",
agencyLicense: "Numéro de licence/agrément",
agencyAnnualClients: "Nombre de clients annuel",
agencyCommission: "Commission souhaitée (%)",
agencyEstimatedTurnover: "Volume d'affaires annuel estimé (EUR)",
agencyMoroccoExperience: "Expérience avec le Maroc",
agencyPresentationPlaceholder: "Présentez votre agence, votre expertise, vos valeurs...",

// Annual clients options
selectOption: "Sélectionnez...",
clientsLess100: "Moins de 100 clients",
clients100_500: "100 - 500 clients",
clients500_1000: "500 - 1000 clients",
clients1000_5000: "1000 - 5000 clients",
clientsMore5000: "Plus de 5000 clients",

// Morocco experience options
expNone: "Aucune expérience",
expBeginner: "Débutant (moins de 2 ans)",
expIntermediate: "Intermédiaire (2-5 ans)",
expExperienced: "Expérimenté (plus de 5 ans)",

// Required services block
serviceLabel: "Service",
serviceTypeRequired: "Type de service",
serviceMonthlyVolume: "Volume estimé/mois",
servicePeriod: "Période souhaitée",
serviceDetailedDesc: "Description détaillée",
serviceDelete: "Supprimer",
serviceTypeSelect: "Sélectionnez...",
serviceVolumePlaceholder: "Ex: 50 clients, 10 groupes...",
serviceDescPlaceholder: "Décrivez vos besoins spécifiques...",

// Period options
periodAllYear: "Toute l'année",
periodHighSeason: "Haute saison uniquement",
periodLowSeason: "Basse saison uniquement",
periodOnDemand: "Sur demande",

// Contact fields
// firstName: "Prénom",
// lastName: "Nom",
// emailLabel: "Votre adresse e-mail",
// emailLabelRequired: "Votre adresse e-mail *",
// phoneNumber: "Numéro de téléphone",
// firstNamePh: "Votre prénom",
// lastNamePh: "Votre nom de famille",
contactEmailPh: "Ex: contact@votre-agence.com",
contactPhonePh: "Ex: +33 1 23 45 67 89",

// Submit
// sending: "Envoi en cours...",
agencySubmit: "Envoyer la demande de partenariat",

// Toasts
agencySentOk: "Votre demande de partenariat a été enregistrée avec succès!",
agencyGenericError: "Une erreur est survenue.",
agencyNetworkError: "Une erreur est survenue. Veuillez réessayer plus tard.",

// Validation messages
vAgencyName: "Nom d'agence obligatoire",
vAgencyCountry: "Pays d'origine obligatoire",
vAgencyPresentation: "Présentation obligatoire",
vAgencyServiceProvided: "Sélectionne au moins 1 type de service proposé",
vAgencyLanguage: "Sélectionne au moins 1 langue parlée",
vFirstName: "Prénom obligatoire",
vLastName: "Nom obligatoire",
vEmail: "Email obligatoire",
vPhone: "Téléphone obligatoire",
vRequiredServiceTypePrefix: "Type de service requis obligatoire (Service ",
vRequiredServiceTypeSuffix: ")",

// =============================
// Circuit Sur Mesure
// =============================
customCircuitTitle: "Circuit Sur Mesure",
customCircuitSubtitle:
  "Créez votre voyage personnalisé selon vos envies. Nous nous occupons de tout organiser pour vous offrir une expérience unique.",
customProcessStepLabel: "Étape",
customProcessStep1Title: "Brief voyage",
customProcessStep1Desc: "Partagez vos envies, votre budget et vos dates.",
customProcessStep2Title: "Conception sur mesure",
customProcessStep2Desc: "Notre équipe construit un itinéraire adapté à votre profil.",
customProcessStep3Title: "Validation rapide",
customProcessStep3Desc: "Vous recevez une proposition claire avec prix et options.",
customTrustBanner: "Paiement sécurisé, accompagnement humain et proposition détaillée avant validation.",
customAvgResponse: "Réponse moyenne: 24h",
customInspirations: "Inspirations",
customWhyTailorTitle: "Pourquoi sur mesure ?",
customWhyTailor1: "Itinéraire 100% personnalisé",
customWhyTailor2: "Guide local expert inclus",
customWhyTailor3: "Hébergement à votre choix",
customWhyTailor4: "Transport privé confortable",
customWhyTailor5: "Flexibilité totale",
customTestimonialQuote: "Un voyage inoubliable ! L'équipe a su créer un circuit parfaitement adapté à nos envies. Du désert aux montagnes, chaque étape était magique.",
customTestimonialCaption: "Circuit 10 jours • Famille",

// Success screen
customCircuitSuccessTitle: "Demande envoyée avec succès!",
customCircuitSuccessBody:
  "Nous avons bien reçu votre demande de circuit personnalisé. Notre équipe va l'étudier et vous contactera dans les plus brefs délais.",
customCircuitNew: "Créer un autre circuit",

// Sections
customCircuitGeneralInfo: "Informations générales",
customCircuitStepsTitle: "Étapes de votre circuit",
customCircuitAddStep: "Ajouter une étape",
customCircuitContactInfo: "Informations de contact",
customCircuitExtraInfo: "Demandes spécifiques ou informations complémentaires",

// Fields
customCircuitTripTitle: "Titre de votre circuit",
customCircuitTripTitlePh: "Ex: Découverte du Maroc authentique",
customCircuitPeopleCount: "Nombre de personnes",
customCircuitStartDate: "Date de début souhaitée",
customCircuitTotalDays: "Durée totale (jours)",
customCircuitAccommodation: "Type d'hébergement souhaité",
customCircuitVehicle: "Type de véhicule",
customCircuitBudget: "Budget approximatif par personne (€)",

customCircuitDescription: "Description de votre circuit idéal",
customCircuitDescriptionPh: "Décrivez le type d'expérience que vous souhaitez vivre...",

// Select options accommodation
accStandard: "Standard",
accComfort: "Confort",
accLuxury: "Luxe",
accRiad: "Riad traditionnel",
accMixed: "Mixte",

// Select options vehicle
vehStandard: "Véhicule standard",
vehComfort: "Véhicule confort",
veh4x4: "4x4",
vehMinibus: "Minibus",
vehLuxury: "Véhicule de luxe",

// Step block
customCircuitStepLabel: "Étape",
customCircuitDelete: "Supprimer",
customCircuitCity: "Ville",
customCircuitCityPh: "Ex: Marrakech",
customCircuitStayDays: "Durée (jours)",
customCircuitActivities: "Activités souhaitées",
customCircuitActivitiesPh: "Ex: Visite de la médina, randonnée...",

// Contact fields
firstName: "Prénom",
lastName: "Nom",

emailLabelRequired: "Votre adresse e-mail *",
phoneNumber: "Numéro de téléphone",
firstNamePh: "Votre prénom",
lastNamePh: "Votre nom de famille",
customCircuitEmailPh: "Ex: vous@example.com",
customCircuitPhonePh: "Ex: +212 600 000000",

// Extra textarea
customCircuitExtraPh: "Précisez vos attentes particulières, contraintes, préférences...",

// Submit
sending: "Envoi en cours...",
submitRequest: "Soumettre ma demande",

// Toasts / Validation
vCustomTitle: "Veuillez saisir un titre.",
vCustomDescription: "Veuillez décrire votre circuit.",
vCustomStartDate: "Veuillez choisir une date de début.",
vCustomDuration: "Veuillez saisir une durée valide.",
vMissingEmail: "Email manquant.",
customCircuitServerError: "Erreur lors de l’enregistrement.",
customCircuitNetworkError: "Une erreur est survenue. Veuillez réessayer plus tard.",
customCircuitSentOk: "Votre demande de circuit sur mesure a été enregistrée avec succès!",
customCircuitBadge: "Sur mesure",
formErrorsTitle: "Veuillez corriger",
wizCircuit: "Votre circuit",
wizItinerary: "Itinéraire",
wizContact: "Vos coordonnées",
wizBack: "Précédent",
wizNext: "Suivant",
wizVisit: "Visite",
wizStay: "Séjour",
wizTrip: "Trajet",
wizCar: "Véhicule",
wizInfos: "Vos infos",
wizPayment: "Paiement",
vSpecifyPlace: "Veuillez préciser le lieu.",
vTitle: "Veuillez saisir le titre du circuit.",
vDateStep: "Veuillez choisir la date de début.",
vDurationStep: "Veuillez indiquer la durée.",
vDescStep: "La description doit contenir au moins 10 caractères.",
vStep: "Ajoutez au moins une étape avec une ville.",
vNameStep: "Veuillez saisir votre nom et prénom.",
vEmailStep: "Veuillez saisir votre email.",
vPhoneStep: "Veuillez saisir votre téléphone.",

  }
};

// Fonction de traduction qui prend une clé et renvoie la traduction dans la langue spécifiée
export const t = (key, language = 'en') => {
  if (!translations[language]) {
    console.warn(`Language '${language}' not found, falling back to English`);
    language = 'en';
  }
  if (!translations[language][key]) {
    console.warn(`Translation key '${key}' not found in '${language}'`);
    if (translations['en'][key]) {
      return translations['en'][key];
    }
    return key;
  }
  
  return translations[language][key];
};

export default translations;